import { setupLocale } from "survey-creator-core";

export var nlStrings = {
  // survey templates
  survey: {
    // "Edit"
    edit: "Bewerk",
    // "Watch and learn how to create surveys"
    externalHelpLink: "Bekijk en leer hoe u enquêtes maakt",
    // "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber"
    externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
    // "Please drop a question here from the Toolbox."
    dropQuestion: "Stel hier een vraag vanuit de Toolbox.",
    // "Create a rule to customize the flow of the survey."
    addLogicItem: "Maak een regel om de stroom van de enquête aan te passen.",
    // "Copy"
    copy: "Kopiëren",
    // [Auto-translated] "Duplicate"
    duplicate: "Duplicaat",
    // "Add to toolbox"
    addToToolbox: "Toevoegen aan toolbox",
    // "Delete Panel"
    deletePanel: "Paneel verwijderen",
    // "Delete Question"
    deleteQuestion: "Vraag verwijderen",
    // "Convert to"
    convertTo: "Omzetten naar",
    // "Drag element"
    drag: "Sleep element"
  },
  // Creator tabs
  tabs: {
    // "Preview"
    preview: "Test de enquête",
    // "Themes"
    theme: "Thema 's",
    // "Translations"
    translation: "Vertaling",
    // "Designer"
    designer: "Enquête-ontwerper",
    // "JSON Editor"
    json: "JSON-editor",
    // "Logic"
    logic: "Onderzoekslogica"
  },
  // Question types
  qt: {
    // "Default"
    default: "Standaard",
    // "Checkboxes"
    checkbox: "Selectievakje",
    // "Long Text"
    comment: "Commentaar",
    // "Image Picker"
    imagepicker: "Afbeelingsvraag",
    // [Auto-translated] "Ranking"
    ranking: "Ranking",
    // "Image"
    image: "Afbeelding",
    // "Dropdown"
    dropdown: "Keuzelijst",
    // [Auto-translated] "Multi-Select Dropdown"
    tagbox: "Vervolgkeuzemenu voor meerdere selecties",
    // "File Upload"
    file: "Bestandsupload",
    // "HTML"
    html: "Html",
    // "Single-Select Matrix"
    matrix: "Matrix (enkele keuze)",
    // "Multi-Select Matrix"
    matrixdropdown: "Matrix (meerkeuze)",
    // "Dynamic Matrix"
    matrixdynamic: "Matrix (dynamische rijen)",
    // "Multiple Textboxes"
    multipletext: "Meervoudige tekstvak",
    // "Panel"
    panel: "Paneel",
    // "Dynamic Panel"
    paneldynamic: "Paneel (dynamische panelen)",
    // "Radio Button Group"
    radiogroup: "Meerkeuzevraag",
    // "Rating Scale"
    rating: "Beoordeling",
    // [Auto-translated] "Slider"
    slider: "Schuifregelaar",
    // "Single-Line Input"
    text: "Tekstvak",
    // "Yes/No (Boolean)"
    boolean: "Yes/No (Boolean)",
    // "Expression (read-only)"
    expression: "Berekening",
    // "Signature"
    signaturepad: "Handtekening",
    // [Auto-translated] "Button Group"
    buttongroup: "Knoppengroep"
  },
  toolboxCategories: {
    // "General"
    general: "Algemeen",
    // "Choice Questions"
    choice: "Keuzevragen",
    // "Text Input Questions"
    text: "Vragen over tekstinvoer",
    // "Containers"
    containers: "Containers",
    // "Matrix Questions"
    matrix: "Matrix vragen",
    // "Misc"
    misc: "MISC"
  },
  // Strings in SurveyJS Creator
  ed: {
    // "Default ({0})"
    defaultLocale: "Standaard ({0})",
    // "Survey"
    survey: "Enquête",
    // "Settings"
    settings: "Enquête-instellingen",
    // "Open settings"
    settingsTooltip: "Open enquête-instellingen",
    // [Auto-translated] "Survey Settings"
    surveySettings: "Enquête-instellingen",
    // [Auto-translated] "Survey settings"
    surveySettingsTooltip: "Enquête instellingen",
    // [Auto-translated] "Theme Settings"
    themeSettings: "Thema-instellingen",
    // [Auto-translated] "Theme settings"
    themeSettingsTooltip: "Thema instellingen",
    // [Auto-translated] "Creator Settings"
    creatorSettingTitle: "Creator-instellingen",
    // "Show Panel"
    showPanel: "Toon paneel",
    // "Hide Panel"
    hidePanel: "Verberg paneel",
    // [Auto-translated] "Select previous"
    prevSelected: "Selecteer vorige",
    // [Auto-translated] "Select next"
    nextSelected: "Selecteer volgende",
    // [Auto-translated] "Focus previous"
    prevFocus: "Focus vorige",
    // [Auto-translated] "Focus next"
    nextFocus: "Focus volgende",
    // [Auto-translated] "Survey"
    surveyTypeName: "Enquête",
    // [Auto-translated] "Page"
    pageTypeName: "Bladzijde",
    // [Auto-translated] "Panel"
    panelTypeName: "Paneel",
    // [Auto-translated] "Question"
    questionTypeName: "Vraag",
    // [Auto-translated] "Column"
    columnTypeName: "Kolom",
    // "Add New Page"
    addNewPage: "Pagina toevoegen",
    // "Scroll to the Right"
    moveRight: "Scroll naar rechts",
    // "Scroll to the Left"
    moveLeft: "Scroll naar links",
    // "Delete Page"
    deletePage: "Pagina verwijderen",
    // "Edit Page"
    editPage: "Pagina aanpassen",
    // "Edit"
    edit: "Bewerk",
    // "page"
    newPageName: "Pagina",
    // "question"
    newQuestionName: "Vraag",
    // "panel"
    newPanelName: "Paneel",
    // "text"
    newTextItemName: "Tekst",
    // [Auto-translated] "Default"
    defaultV2Theme: "Verstek",
    // [Auto-translated] "Modern"
    modernTheme: "Modern",
    // [Auto-translated] "Default (legacy)"
    defaultTheme: "Standaard (verouderd)",
    // "Preview Survey Again"
    testSurveyAgain: "Test de enquête opnieuw",
    // "Survey width: "
    testSurveyWidth: "Onderzoeksbreedte: ",
    // "You had to navigate to"
    navigateToMsg: "Je moest navigeren naar:",
    // "Save Survey"
    saveSurvey: "Enquête opslaan",
    // "Save Survey"
    saveSurveyTooltip: "Enquête opslaan",
    // [Auto-translated] "Save Theme"
    saveTheme: "Thema opslaan",
    // [Auto-translated] "Save Theme"
    saveThemeTooltip: "Thema opslaan",
    // [Auto-translated] "Hide errors"
    jsonHideErrors: "Fouten verbergen",
    // [Auto-translated] "Show errors"
    jsonShowErrors: "Toon fouten",
    // "Undo"
    undo: "Ongedaan maken",
    // "Redo"
    redo: "Opnieuw uitvoeren",
    // "Undo last change"
    undoTooltip: "Maak de laatste wijziging ongedaan",
    // "Redo the change"
    redoTooltip: "Voer de wijziging opnieuw uit",
    // [Auto-translated] "Expand"
    expandTooltip: "Uitbreiden",
    // [Auto-translated] "Collapse"
    collapseTooltip: "Instorting",
    // "Expand All"
    expandAllTooltip: "Alles uitvouwen",
    // "Collapse All"
    collapseAllTooltip: "Alles inklappen",
    // [Auto-translated] "Zoom In"
    zoomInTooltip: "Inzoomen",
    // [Auto-translated] "Zoom to 100%"
    zoom100Tooltip: "Inzoomen tot 100%",
    // [Auto-translated] "Zoom Out"
    zoomOutTooltip: "Uitzoomen",
    // [Auto-translated] "Lock expand/collapse state for questions"
    lockQuestionsTooltip: "Vergrendel de uitvouw-/samenvouwstatus voor vragen",
    // [Auto-translated] "Show more"
    showMoreChoices: "Toon meer",
    // [Auto-translated] "Show less"
    showLessChoices: "Toon minder",
    // "Copy"
    copy: "Kopiëren",
    // "Cut"
    cut: "Besnoeiing",
    // "Paste"
    paste: "Plakken",
    // "Copy selection to clipboard"
    copyTooltip: "Kopieer selectie naar klembord",
    // "Cut selection to clipboard"
    cutTooltip: "Knip de selectie naar het klembord",
    // "Paste from clipboard"
    pasteTooltip: "Plakken vanaf klembord",
    // "Options"
    options: "Opties",
    // "Generate Valid JSON"
    generateValidJSON: "Genereer geldige JSON",
    // "Generate Readable JSON"
    generateReadableJSON: "Genereer leesbare JSON",
    // "Toolbox"
    toolbox: "Gereedschap",
    // "Properties"
    "property-grid": "Eigenschappen",
    // [Auto-translated] "Search"
    toolboxSearch: "Zoeken",
    // [Auto-translated] "Type to search..."
    toolboxFilteredTextPlaceholder: "Typ om te zoeken...",
    // [Auto-translated] "No results found"
    toolboxNoResultsFound: "Geen resultaten gevonden",
    // [Auto-translated] "No properties to display"
    propertyGridEmptySurveyText: "Geen eigenschappen om te tonen",
    // [Auto-translated] "Type to search..."
    propertyGridFilteredTextPlaceholder: "Typ om te zoeken...",
    // [Auto-translated] "No results found"
    propertyGridNoResultsFound: "Geen resultaten gevonden",
    // [Auto-translated] "Start configuring your form"
    propertyGridPlaceholderTitle: "Begin met het configureren van uw formulier",
    // [Auto-translated] "Click any category icon to explore survey settings. Additional settings will become available once you add a survey element to the design surface."
    propertyGridPlaceholderDescription: "Klik op een categoriepictogram om de enquête-instellingen te verkennen. Aanvullende instellingen worden beschikbaar zodra u een enquête-element aan het ontwerpoppervlak toevoegt.",
    // "Please correct JSON."
    correctJSON: "Corrigeer JSON.",
    // "Survey Results "
    surveyResults: "Enquêteresultaat: ",
    // "As Table"
    surveyResultsTable: "Als tabel",
    // "As JSON"
    surveyResultsJson: "Als JSON",
    // "Question Title"
    resultsTitle: "Vraag titel",
    // "Question Name"
    resultsName: "Vraag naam",
    // "Answer Value"
    resultsValue: "Antwoordwaarde",
    // "Display Value"
    resultsDisplayValue: "Waarde weergeven",
    // "Modified"
    modified: "Gewijzigd",
    // "Saving"
    saving: "Besparing",
    // "Saved"
    saved: "Opgeslagen",
    // "Error"
    propertyEditorError: "Fout:",
    // "Error! Editor content is not saved."
    saveError: "Fout! De inhoud van de editor wordt niet opgeslagen.",
    // [Auto-translated] "Language Settings"
    translationPropertyGridTitle: "Taalinstellingen",
    // [Auto-translated] "Theme Settings"
    themePropertyGridTitle: "Thema-instellingen",
    // [Auto-translated] "Add Language"
    addLanguageTooltip: "Taal toevoegen",
    // [Auto-translated] "Languages"
    translationLanguages: "Talen",
    // [Auto-translated] "Are you certain you wish to delete all strings for this language?"
    translationDeleteLanguage: "Weet u zeker dat u alle tekenreeksen voor deze taal wilt verwijderen?",
    // "Select language to translate"
    translationAddLanguage: "Selecteer de taal om te vertalen",
    // "All Strings"
    translationShowAllStrings: "Toon alle snaren",
    // [Auto-translated] "Used Strings Only"
    translationShowUsedStringsOnly: "Alleen gebruikte tekenreeksen",
    // "All Pages"
    translationShowAllPages: "Toon alle paginas",
    // "No strings to translate. Please change the filter."
    translationNoStrings: "Geen verplichtingen om te vertalen. Vervang alstublieft het filter.",
    // "Export to CSV"
    translationExportToSCVButton: "Exporteren naar CSV",
    // "Import from CSV"
    translationImportFromSCVButton: "Importeren vanuit CSV",
    // [Auto-translated] "Auto-translate All"
    translateUsigAI: "Alles automatisch vertalen",
    // [Auto-translated] "Translate from: "
    translateUsigAIFrom: "Vertalen van: ",
    // [Auto-translated] "Untranslated strings"
    translationDialogTitle: "Onvertaalde tekenreeksen",
    // "Merge {0} with default locale"
    translationMergeLocaleWithDefault: "Voeg {0} samen met de standaardlandinstelling",
    // [Auto-translated] "Translation..."
    translationPlaceHolder: "Vertaling...",
    // [Auto-translated] "Source: "
    translationSource: "Bron: ",
    // [Auto-translated] "Target: "
    translationTarget: "Doel: ",
    // [Auto-translated] "YouTube links are not supported."
    translationYouTubeNotSupported: "YouTube-links worden niet ondersteund.",
    // [Auto-translated] "Export"
    themeExportButton: "Exporteren",
    // [Auto-translated] "Import"
    themeImportButton: "Importeren",
    // [Auto-translated] "Export"
    surveyJsonExportButton: "Exporteren",
    // [Auto-translated] "Import"
    surveyJsonImportButton: "Importeren",
    // [Auto-translated] "Copy to clipboard"
    surveyJsonCopyButton: "Naar klembord kopiëren",
    // [Auto-translated] "Reset theme settings to default"
    themeResetButton: "Thema-instellingen terugzetten op de standaardinstellingen",
    // [Auto-translated] "Do you really want to reset the theme? All your customizations will be lost."
    themeResetConfirmation: "Wil je het thema echt resetten? Al uw aanpassingen gaan verloren.",
    // [Auto-translated] "Yes, reset the theme"
    themeResetConfirmationOk: "Ja, reset het thema",
    // "Bold"
    bold: "Vetgedrukt",
    // "Italic"
    italic: "Cursief",
    // "Underline"
    underline: "Onderstrepen",
    // "Add Question"
    addNewQuestion: "Vraag toevoegen",
    // "Select page..."
    selectPage: "Selecteer pagina...",
    // [Auto-translated] "Choices are copied from"
    carryForwardChoicesCopied: "Keuzes worden gekopieerd van",
    // [Auto-translated] "Choices are loaded from a web service."
    choicesLoadedFromWebText: "Keuzes worden geladen vanuit een webservice.",
    // [Auto-translated] "Go to settings"
    choicesLoadedFromWebLinkText: "Ga naar instellingen",
    // [Auto-translated] "Preview of loaded choice options"
    choicesLoadedFromWebPreviewTitle: "Voorbeeld van geladen keuzeopties",
    // [Auto-translated] "HTML content will be here."
    htmlPlaceHolder: "HTML-inhoud zal hier zijn.",
    // [Auto-translated] "Drop a question from the toolbox here."
    panelPlaceHolder: "Drop hier een vraag uit de toolbox.",
    // [Auto-translated] "The survey is empty. Drag an element from the toolbox or click the button below."
    surveyPlaceHolder: "De enquête is leeg. Sleep een element uit de gereedschapskist of klik op de onderstaande knop.",
    // [Auto-translated] "The page is empty. Drag an element from the toolbox or click the button below."
    pagePlaceHolder: "De pagina is leeg. Sleep een element uit de gereedschapskist of klik op de knop hieronder.",
    // [Auto-translated] "Drag and drop an image here or click the button below and choose an image to upload"
    imagePlaceHolder: "Sleep een afbeelding hierheen of klik op de onderstaande knop en kies een afbeelding om te uploaden",
    // "Click the \"Add Question\" button below to start creating your form."
    surveyPlaceHolderMobile: "Klik hieronder op de knop \"Vraag toevoegen\" om te beginnen met het maken van uw formulier.",
    // [Auto-translated] "Your form is empty"
    surveyPlaceholderTitle: "Uw formulier is leeg",
    // [Auto-translated] "Your form is empty"
    surveyPlaceholderTitleMobile: "Uw formulier is leeg",
    // [Auto-translated] "Drag an element from the toolbox or click the button below."
    surveyPlaceholderDescription: "Sleep een element uit de gereedschapskist of klik op de knop hieronder.",
    // [Auto-translated] "Drag an element from the toolbox or click the button below."
    surveyPlaceholderDescriptionMobile: "Sleep een element uit de gereedschapskist of klik op de knop hieronder.",
    // [Auto-translated] "No preview"
    previewPlaceholderTitle: "Geen voorbeeld",
    // [Auto-translated] "No preview"
    previewPlaceholderTitleMobile: "Geen voorbeeld",
    // [Auto-translated] "The survey doesn't contain any visible elements."
    previewPlaceholderDescription: "De enquête bevat geen zichtbare elementen.",
    // [Auto-translated] "The survey doesn't contain any visible elements."
    previewPlaceholderDescriptionMobile: "De enquête bevat geen zichtbare elementen.",
    // [Auto-translated] "No strings to translate"
    translationsPlaceholderTitle: "Geen verplichtingen om te vertalen",
    // [Auto-translated] "No strings to translate"
    translationsPlaceholderTitleMobile: "Geen verplichtingen om te vertalen",
    // [Auto-translated] "Add elements to your form or change the strings filter in the toolbar."
    translationsPlaceholderDescription: "Voeg elementen toe aan uw formulier of wijzig het tekenreeksfilter in de werkbalk.",
    // [Auto-translated] "Add elements to your form or change the strings filter in the toolbar."
    translationsPlaceholderDescriptionMobile: "Voeg elementen toe aan uw formulier of wijzig het tekenreeksfilter in de werkbalk.",
    // "Click the \"Add Question\" button below to add a new element to the page."
    pagePlaceHolderMobile: "Klik op de knop \"Vraag toevoegen\" hieronder om een nieuw element aan de pagina toe te voegen.",
    // "Click the \"Add Question\" button below to add a new element to the panel."
    panelPlaceHolderMobile: "Klik op de knop \"Vraag toevoegen\" hieronder om een nieuw element aan het paneel toe te voegen.",
    // [Auto-translated] "Click the button below and choose an image to upload"
    imagePlaceHolderMobile: "Klik op de onderstaande knop en kies een afbeelding om te uploaden",
    // [Auto-translated] "Choose Image"
    imageChooseImage: "Kies afbeelding",
    // [Auto-translated] "Add {0}"
    addNewTypeQuestion: "Voeg {0} toe", // {0} is localizable question type
    // [Auto-translated] "[LOGO]"
    chooseLogoPlaceholder: "[LOGO]",
    // [Auto-translated] "Item "
    choices_Item: "Item ",
    // [Auto-translated] "Select a file"
    selectFile: "Selecteer een bestand",
    // [Auto-translated] "Remove the file"
    removeFile: "Verwijder het bestand",
    lg: {
      // [Auto-translated] "Add New Rule"
      addNewItem: "Nieuwe regel toevoegen",
      // [Auto-translated] "Create a rule to customize the flow of the survey."
      empty_tab: "Maak een regel om de stroom van de enquête aan te passen.",
      // [Auto-translated] "No logical rules"
      logicPlaceholderTitle: "Geen logische regels",
      // [Auto-translated] "No logical rules"
      logicPlaceholderTitleMobile: "Geen logische regels",
      // [Auto-translated] "Create a rule to customize the flow of the survey."
      logicPlaceholderDescription: "Maak een regel om de stroom van de enquête aan te passen.",
      // [Auto-translated] "Create a rule to customize the flow of the survey."
      logicPlaceholderDescriptionMobile: "Maak een regel om de stroom van de enquête aan te passen.",
      // "Show/hide page"
      page_visibilityName: "Pagina zichtbaarheid",
      // [Auto-translated] "Enable/disable page"
      page_enableName: "Pagina in-/uitschakelen",
      // [Auto-translated] "Make page required"
      page_requireName: "Pagina verplicht maken",
      // "Show/hide panel"
      panel_visibilityName: "Paneel zichtbaarheid",
      // "Enable/disable panel"
      panel_enableName: "Paneel inschakelen/uitschakelen",
      // [Auto-translated] "Make panel required"
      panel_requireName: "Paneel verplicht maken",
      // "Show/hide question"
      question_visibilityName: "Vraag zichtbaarheid",
      // "Enable/disable question"
      question_enableName: "Vraag inschakelen/uitschakelen",
      // "Make question required"
      question_requireName: "Vraag optioneel vereist",
      // [Auto-translated] "Reset question value"
      question_resetValueName: "Vraagwaarde opnieuw instellen",
      // [Auto-translated] "Set question value"
      question_setValueName: "Vraagwaarde instellen",
      // [Auto-translated] "Show/hide column"
      column_visibilityName: "Kolom Tonen/verbergen",
      // [Auto-translated] "Enable/disable column"
      column_enableName: "Kolom in-/uitschakelen",
      // [Auto-translated] "Make column required"
      column_requireName: "Kolom verplicht maken",
      // [Auto-translated] "Reset column value"
      column_resetValueName: "Kolomwaarde opnieuw instellen",
      // [Auto-translated] "Set column value"
      column_setValueName: "Kolomwaarde instellen",
      // "Complete survey"
      trigger_completeName: "Volledige enquête",
      // "Set answer"
      trigger_setvalueName: "Stel vraagwaarde in",
      // "Copy answer"
      trigger_copyvalueName: "Kopieer de vraagwaarde",
      // "Skip to question"
      trigger_skipName: "Ga naar de vraag",
      // "Run expression"
      trigger_runExpressionName: "Voer een aangepaste expressie uit",
      // "Set \"Thank You\" page markup"
      completedHtmlOnConditionName: "Aangepaste 'Bedanktpagina'-tekst",
      // "Make the page visible when the logical expression evaluates to true. Otherwise, keep the page invisible."
      page_visibilityDescription: "Maak de pagina zichtbaar wanneer de logische uitdrukking true retourneert. Houd het anders onzichtbaar.",
      // "Make the page visible when the logical expression evaluates to true. Otherwise, keep the panel invisible."
      panel_visibilityDescription: "Maak het paneel zichtbaar wanneer de logische uitdrukking true retourneert. Houd het anders onzichtbaar.",
      // "Make the panel and all elements inside it enabled when the logical expression evaluates to true. Otherwise, keep them disabled."
      panel_enableDescription: "Zorg ervoor dat het paneel en alle elementen erin worden ingeschakeld wanneer de logische uitdrukking true retourneert. Houd ze anders uitgeschakeld.",
      // "Make the question visible when the logical expression evaluates to true. Otherwise, keep the question invisible."
      question_visibilityDescription: "Maak de vraag zichtbaar wanneer de logische uitdrukking true retourneert. Houd het anders onzichtbaar.",
      // "Make the question enabled when the logical expression evaluates to true. Otherwise, keep the question disabled."
      question_enableDescription: "Schakel de vraag in wanneer de logische uitdrukking true retourneert. Houd het anders uitgeschakeld.",
      // "Question becomes required when the logical expression evaluates to true."
      question_requireDescription: "Vraag wordt vereist wanneer de logische uitdrukking true retourneert.",
      // "When the logical expression evaluates to true, the survey ends, and the respondent sees the \"Thank you\" page."
      trigger_completeDescription: "Wanneer de logische uitdrukking true retourneert, wordt de enquête voltooid en ziet een eindgebruiker de 'Bedankpagina'.",
      // "When question values used in the logical expression are changed, and the expression evaluates to true, the specified value is assigned to the selected question."
      trigger_setvalueDescription: "Wanneer vraagwaarden, die worden gebruikt in de logische uitdrukking, worden gewijzigd en de logische uitdrukking true retourneert, wordt de waarde ingesteld op de geselecteerde vraag.",
      // "When question values used in the logical expression are changed, and the expression evaluates to true, the value of the selected question is copied to another question."
      trigger_copyvalueDescription: "Wanneer vraagwaarden, die worden gebruikt in de logische uitdrukking, worden gewijzigd en de logische uitdrukking true retourneert, wordt de waarde van een geselecteerde vraag gekopieerd naar een andere geselecteerde vraag.",
      // "When the logical expression evaluates to true, the survey focuses/jumps to the selected question."
      trigger_skipDescription: "Als de logische uitdrukking true retourneert, gaat de enquête naar/focust de geselecteerde vraag.",
      // "When the logical expression evaluates to true, the survey evaluates another expression. Optionally, the result of the latter expression can be assigned as a value to the selected question"
      trigger_runExpressionDescription: "Wanneer de logische expressie true retourneert, wordt de aangepaste expressie uitgevoerd. U kunt dit expressieresultaat optioneel instellen voor de geselecteerde vraag",
      // "If the logical expression evaluates to true, the \"Thank You\" page displays the specified content."
      completedHtmlOnConditionDescription: "Als de logische uitdrukking true retourneert, wordt de standaardtekst voor de 'Bedankpagina' gewijzigd in de opgegeven tekst.",
      // "When expression: '{0}' returns true"
      itemExpressionText: "Wanneer expressie: '{0}' true retourneert:", // {0} - the expression
      // [Auto-translated] "New rule"
      itemEmptyExpressionText: "Nieuwe regel",
      // "make page {0} visible"
      page_visibilityText: "Maak pagina {0} zichtbaar", // {0} page name
      // "make panel {0} visible"
      panel_visibilityText: "Maak paneel {0} zichtbaar", // {0} panel name
      // "make panel {0} enable"
      panel_enableText: "Schakel paneel {0} in", // {0} panel name
      // "make question {0} visible"
      question_visibilityText: "Maak vraag {0} zichtbaar", // {0} question name
      // "make question {0} enable"
      question_enableText: "Schakel vraag {0} in", // {0} question name
      // "make question {0} required"
      question_requireText: "Stel vraag {0} verplicht", // {0} question name
      // [Auto-translated] "reset value for question: {0}"
      question_resetValueText: "Resetwaarde voor vraag: {0}", // {0} question name.
      // [Auto-translated] "assign value: {1} to question: {0}"
      question_setValueText: "Waarde: {1} toewijzen aan vraag: {0}", // {0} question name and {1} setValueExpression
      // [Auto-translated] "make column {0} of question {1} visible"
      column_visibilityText: "Kolom {0} van vraag {1} zichtbaar maken", // {0} column name, {1} question name
      // [Auto-translated] "make column {0} of question {1} enable"
      column_enableText: "Kolom {0} van vraag maken {1} inschakelen", // {0} column name, {1} question name
      // [Auto-translated] "make column {0} of question {1} required"
      column_requireText: "Kolom {0} met vraag {1} verplicht maken", // {0} column name, {1} question name
      // [Auto-translated] "reset cell value for column: {0}"
      column_resetValueText: "Celwaarde voor kolom opnieuw instellen: {0}", // {0} column name
      // [Auto-translated] "assign cell value: {1} to column: {0}"
      column_setValueText: "Celwaarde: {1} toewijzen aan kolom: {0}", // {0} column name and {1} setValueExpression
      // [Auto-translated] "An expression whose result will be assigned to the target question."
      setValueExpressionPlaceholder: "Een expressie waarvan het resultaat wordt toegewezen aan de doelvraag.",
      // "survey becomes completed"
      trigger_completeText: "Enquête wordt voltooid",
      // "set into question: {0} value {1}"
      trigger_setvalueText: "Stel de vraag: {0} waarde {1}", // {0} question name, {1} setValue
      // [Auto-translated] "clear question value: {0}"
      trigger_setvalueEmptyText: "verwijder vraagwaarde: {0}", // {0} question name
      // "copy into question: {0} value from question {1}"
      trigger_copyvalueText: "Kopieer naar vraag: {0} waarde uit vraag {1}", // {0} and {1} question names
      // "survey skip to the question {0}"
      trigger_skipText: "Enquête ga verder met de vraag {0}", // {0} question name
      // "run expression: '{0}'"
      trigger_runExpressionText1: "Uitdrukking uitvoeren: '{0}'", // {0} the expression
      // " and set its result into question: {0}"
      trigger_runExpressionText2: " en stel het resultaat in vraag: {0}", // {0} question name
      // "show custom text for the \"Thank You\" page."
      completedHtmlOnConditionText: "Toon aangepaste tekst voor de 'Bedankpagina'.",
      // [Auto-translated] "All Questions"
      showAllQuestions: "Alle vragen",
      // [Auto-translated] "All Action Types"
      showAllActionTypes: "Alle actietypen",
      // "Condition(s)"
      conditions: "Voorwaard(en)",
      // "Action(s)"
      actions: "Actie(s)",
      // "Define condition(s)"
      expressionEditorTitle: "Definieer conditie(s)",
      // "Define action(s)"
      actionsEditorTitle: "Definieer actie(s)",
      // "Delete Action"
      deleteAction: "Actie verwijderen",
      // "Add Action"
      addNewAction: "Voeg nieuwe actie toe",
      // "Select action..."
      selectedActionCaption: "Selecteer een actie om toe te voegen...",
      // "The logic expression is empty or invalid. Please correct it."
      expressionInvalid: "De logische uitdrukking is leeg of ongeldig. Verbeter dit alstublieft.",
      // "Please add at least one action."
      noActionError: "Voeg ten minste één actie toe.",
      // "Please fix issues in your action(s)."
      actionInvalid: "Los problemen in uw actie(s) op.",
      // [Auto-translated] "Logical rules are incomplete"
      uncompletedRule_title: "Logische regels zijn onvolledig",
      // [Auto-translated] "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?"
      uncompletedRule_text: "U hebt een aantal van de logische regels niet voltooid. Als u het tabblad nu verlaat, gaan de wijzigingen verloren. Wilt u het tabblad nog steeds verlaten zonder de wijzigingen te voltooien?",
      // [Auto-translated] "Yes"
      uncompletedRule_apply: "Ja",
      // [Auto-translated] "No, I want to complete the rules"
      uncompletedRule_cancel: "Nee, ik wil de regels invullen"
    }
  },
  // Property Editors
  pe: {
    panel: {
      // [Auto-translated] "Panel name"
      name: "Naam van het paneel",
      // [Auto-translated] "Panel title"
      title: "Titel van het paneel",
      // [Auto-translated] "Panel description"
      description: "Beschrijving van het paneel",
      // [Auto-translated] "Make the panel visible if"
      visibleIf: "Maak het paneel zichtbaar als",
      // [Auto-translated] "Make the panel required if"
      requiredIf: "Maak het paneel vereist als",
      // [Auto-translated] "Question order within the panel"
      questionOrder: "Volgorde van de vragen binnen het panel",
      // [Auto-translated] "Move the panel to page"
      page: "Het deelvenster naar pagina verplaatsen",
      // [Auto-translated] "Display the panel on a new line"
      startWithNewLine: "Het paneel op een nieuwe regel weergeven",
      // [Auto-translated] "Panel collapse state"
      state: "Status van paneel samenvouwen",
      // [Auto-translated] "Inline panel width"
      width: "Breedte inline paneel",
      // [Auto-translated] "Minimum panel width"
      minWidth: "Minimale paneelbreedte",
      // [Auto-translated] "Maximum panel width"
      maxWidth: "Maximale paneelbreedte",
      // [Auto-translated] "Number this panel"
      showNumber: "Nummer dit paneel"
    },
    panellayoutcolumn: {
      // [Auto-translated] "Effective width, %"
      effectiveWidth: "Effectieve breedte, %",
      // [Auto-translated] "Question title width, px"
      questionTitleWidth: "Breedte van de vraagtitel, px"
    },
    paneldynamic: {
      // [Auto-translated] "Panel name"
      name: "Naam van het paneel",
      // [Auto-translated] "Panel title"
      title: "Titel van het paneel",
      // [Auto-translated] "Panel description"
      description: "Beschrijving van het paneel",
      // [Auto-translated] "Entry display mode"
      displayMode: "Weergavemodus bij binnenkomst",
      // [Auto-translated] "Make the panel visible if"
      visibleIf: "Maak het paneel zichtbaar als",
      // [Auto-translated] "Make the panel required if"
      requiredIf: "Maak het paneel vereist als",
      // [Auto-translated] "Move the panel to page"
      page: "Het deelvenster naar pagina verplaatsen",
      // [Auto-translated] "Display the panel on a new line"
      startWithNewLine: "Het paneel op een nieuwe regel weergeven",
      // [Auto-translated] "Panel collapse state"
      state: "Status van paneel samenvouwen",
      // [Auto-translated] "Inline panel width"
      width: "Inline paneelbreedte",
      // [Auto-translated] "Minimum panel width"
      minWidth: "Minimale paneelbreedte",
      // [Auto-translated] "Maximum panel width"
      maxWidth: "Maximale paneelbreedte",
      // [Auto-translated] "Confirm entry removal"
      confirmDelete: "Bevestig de verwijdering van de invoer",
      // [Auto-translated] "Entry description pattern"
      templateDescription: "Patroon invoerbeschrijving",
      // [Auto-translated] "Entry title pattern"
      templateTitle: "Patroon voor de titel van het item",
      // [Auto-translated] "Empty panel text"
      noEntriesText: "Lege paneeltekst",
      // [Auto-translated] "Tab title pattern"
      templateTabTitle: "Patroon voor tabbladtitel",
      // [Auto-translated] "Tab title placeholder"
      tabTitlePlaceholder: "Tijdelijke aanduiding voor tabtitel",
      // [Auto-translated] "Make an individual entry visible if"
      templateVisibleIf: "Maak een individuele invoer zichtbaar als",
      // [Auto-translated] "Number the panel"
      showNumber: "Nummer het paneel",
      // [Auto-translated] "Panel title alignment"
      titleLocation: "Uitlijning van paneeltitels",
      // [Auto-translated] "Panel description alignment"
      descriptionLocation: "Uitlijning van paneelbeschrijving",
      // [Auto-translated] "Question title alignment"
      templateQuestionTitleLocation: "Uitlijning van vraagtitel",
      // [Auto-translated] "Question title width"
      templateQuestionTitleWidth: "Breedte van de vraagtitel",
      // [Auto-translated] "Error message alignment"
      templateErrorLocation: "Uitlijning van foutmeldingen",
      // [Auto-translated] "New entry location"
      newPanelPosition: "Nieuwe ingangslocatie",
      // [Auto-translated] "Prevent duplicate responses in the following question"
      keyName: "Voorkom dubbele antwoorden op de volgende vraag"
    },
    question: {
      // [Auto-translated] "Question name"
      name: "Naam van de vraag",
      // [Auto-translated] "Question title"
      title: "Titel van de vraag",
      // [Auto-translated] "Question description"
      description: "Beschrijving van de vraag",
      // [Auto-translated] "Show the title and description"
      showTitle: "Toon de titel en beschrijving",
      // [Auto-translated] "Make the question visible if"
      visibleIf: "Maak de vraag zichtbaar als",
      // [Auto-translated] "Make the question required if"
      requiredIf: "Maak de vraag verplicht als",
      // [Auto-translated] "Move the question to page"
      page: "Verplaats de vraag naar pagina",
      // [Auto-translated] "Question box collapse state"
      state: "Samenvouwen van vragenvak",
      // [Auto-translated] "Number this question"
      showNumber: "Nummer deze vraag",
      // [Auto-translated] "Question title alignment"
      titleLocation: "Uitlijning van vraagtitels",
      // [Auto-translated] "Question description alignment"
      descriptionLocation: "Uitlijning van vraagbeschrijvingen",
      // [Auto-translated] "Error message alignment"
      errorLocation: "Uitlijning van foutmeldingen",
      // [Auto-translated] "Increase the inner indent"
      indent: "Vergroot de binnenste inkeping",
      // [Auto-translated] "Inline question width"
      width: "Breedte inline vraag",
      // [Auto-translated] "Minimum question width"
      minWidth: "Minimale vraagbreedte",
      // [Auto-translated] "Maximum question width"
      maxWidth: "Maximale vraagbreedte",
      // [Auto-translated] "Update input field value"
      textUpdateMode: "Invoerveldwaarde bijwerken"
    },
    signaturepad: {
      // [Auto-translated] "Signature area width"
      signatureWidth: "Breedte van het signatuurgebied",
      // [Auto-translated] "Signature area height"
      signatureHeight: "Hoogte van het kenmerkende gebied",
      // [Auto-translated] "Auto-scale the signature area"
      signatureAutoScaleEnabled: "Het handtekeninggebied automatisch schalen",
      // [Auto-translated] "Show a placeholder within signature area"
      showPlaceholder: "Een tijdelijke aanduiding weergeven in het ondertekeningsgebied",
      // [Auto-translated] "Placeholder text"
      placeholder: "Tijdelijke aanduiding voor tekst",
      // [Auto-translated] "Placeholder text in read-only or preview mode"
      placeholderReadOnly: "Tijdelijke tekst in de modus Alleen-lezen of voorvertoning",
      // [Auto-translated] "Show the Clear button within signature area"
      allowClear: "Toon de knop Wissen in het handtekeninggebied",
      // [Auto-translated] "Minimum stroke width"
      penMinWidth: "Minimale lijndikte",
      // [Auto-translated] "Maximum stroke width"
      penMaxWidth: "Maximale lijnbreedte",
      // [Auto-translated] "Stroke color"
      penColor: "Kleur van de lijn"
    },
    comment: {
      // [Auto-translated] "Input field height (in lines)"
      rows: "Hoogte invoerveld (in lijnen)"
    },
    // "Question numbering"
    showQuestionNumbers: "Toon vraagnummers",
    // "Question indexing type"
    questionStartIndex: "Eerste vraag (1, 2 or 'A', 'a')",
    expression: {
      // [Auto-translated] "Expression name"
      name: "Naam van expressie",
      // [Auto-translated] "Expression title"
      title: "Titel van expressie",
      // [Auto-translated] "Expression description"
      description: "Beschrijving van expressie",
      // [Auto-translated] "Expression"
      expression: "Uitdrukking"
    },
    trigger: {
      // [Auto-translated] "Expression"
      expression: "Uitdrukking"
    },
    calculatedvalue: {
      // [Auto-translated] "Expression"
      expression: "Uitdrukking"
    },
    // survey templates
    survey: {
      // [Auto-translated] "Survey title"
      title: "Titel van de enquête",
      // [Auto-translated] "Survey description"
      description: "Beschrijving van de enquête",
      // [Auto-translated] "Make the survey read-only"
      readOnly: "De enquête alleen-lezen maken"
    },
    page: {
      // [Auto-translated] "Page name"
      name: "Paginanaam",
      // [Auto-translated] "Page title"
      title: "Titel van de pagina",
      // [Auto-translated] "Page description"
      description: "Pagina beschrijving",
      // [Auto-translated] "Make the page visible if"
      visibleIf: "Maak de pagina zichtbaar als",
      // [Auto-translated] "Make the page required if"
      requiredIf: "Maak de pagina vereist als",
      // [Auto-translated] "Time limit to complete the page"
      timeLimit: "Tijdslimiet om de pagina te voltooien",
      // [Auto-translated] "Question order on the page"
      questionOrder: "Volgorde van vragen op de pagina"
    },
    matrixdropdowncolumn: {
      // [Auto-translated] "Column name"
      name: "Naam van de kolom",
      // [Auto-translated] "Column title"
      title: "Titel van de kolom",
      // [Auto-translated] "Prevent duplicate responses"
      isUnique: "Voorkom dubbele reacties",
      // [Auto-translated] "Column width"
      width: "Kolombreedte",
      // [Auto-translated] "Minimum column width"
      minWidth: "Minimale kolombreedte",
      // [Auto-translated] "Input field height (in lines)"
      rows: "Hoogte invoerveld (in lijnen)",
      // [Auto-translated] "Make the column visible if"
      visibleIf: "Maak de kolom zichtbaar als",
      // [Auto-translated] "Make the column required if"
      requiredIf: "Maak de kolom verplicht als",
      // [Auto-translated] "Each option in a separate column"
      showInMultipleColumns: "Elke optie in een aparte kolom"
    },
    matrixcolumn: {
      // [Auto-translated] "Clear others in the same row"
      isExclusive: "Anderen in dezelfde rij wissen"
    },
    multipletextitem: {
      // [Auto-translated] "Name"
      name: "Naam",
      // [Auto-translated] "Title"
      title: "Titel"
    },
    masksettings: {
      // [Auto-translated] "Save masked value in survey results"
      saveMaskedValue: "Gemaskeerde waarde opslaan in enquêteresultaten"
    },
    patternmask: {
      // [Auto-translated] "Value pattern"
      pattern: "Waardepatroon"
    },
    datetimemask: {
      // [Auto-translated] "Minimum value"
      min: "Minimumwaarde",
      // [Auto-translated] "Maximum value"
      max: "Maximale waarde"
    },
    numericmask: {
      // [Auto-translated] "Allow negative values"
      allowNegativeValues: "Negatieve waarden toestaan",
      // [Auto-translated] "Thousands separator"
      thousandsSeparator: "Scheidingsteken voor duizendtallen",
      // [Auto-translated] "Decimal separator"
      decimalSeparator: "Decimaalteken",
      // [Auto-translated] "Value precision"
      precision: "Waarde precisie",
      // [Auto-translated] "Minimum value"
      min: "Minimumwaarde",
      // [Auto-translated] "Maximum value"
      max: "Maximale waarde"
    },
    currencymask: {
      // [Auto-translated] "Currency prefix"
      prefix: "Valuta voorvoegsel",
      // [Auto-translated] "Currency suffix"
      suffix: "Valuta achtervoegsel"
    },
    // [Auto-translated] "Clear others when selected"
    isExclusive: "Anderen wissen wanneer geselecteerd",
    // [Auto-translated] "Display both text and value"
    showValue: "Geef zowel tekst als waarde weer",
    // [Auto-translated] "Require user to enter a comment"
    isCommentRequired: "Vereisen dat de gebruiker een opmerking invoert",
    // "Display area height"
    imageHeight: "Afbeelding hoogte",
    // "Display area width"
    imageWidth: "Afbeelding breedte",
    // "Join identifier"
    valueName: "Waardenaam",
    // [Auto-translated] "Default display value for dynamic texts"
    defaultDisplayValue: "Standaardweergavewaarde voor dynamische teksten",
    // [Auto-translated] "Label alignment"
    rateDescriptionLocation: "Etiket uitlijnen",
    // [Auto-translated] "Input field width (in characters)"
    size: "Breedte invoerveld (in tekens)",
    // [Auto-translated] "Cell error message alignment"
    cellErrorLocation: "Uitlijning van celfoutmeldingen",
    // [Auto-translated] "Enabled"
    enabled: "Ingeschakeld",
    // [Auto-translated] "Disabled"
    disabled: "Invalide",
    // [Auto-translated] "Inherit"
    inherit: "Erven",
    // "Apply"
    apply: "Van toepassing zijn",
    // "OK"
    ok: "OK",
    // "Save"
    save: "Opslaan",
    // [Auto-translated] "Clear"
    clear: "Verwijder alles",
    // "Save"
    saveTooltip: "Opslaan",
    // "Cancel"
    cancel: "Annuleren",
    // [Auto-translated] "Set"
    set: "Set",
    // "Reset"
    reset: "Resetten",
    // [Auto-translated] "Change"
    change: "Veranderen",
    // "Refresh"
    refresh: "Opslaan",
    // [Auto-translated] "Close"
    close: "Sluiten",
    // "Delete"
    delete: "Verwijderen",
    // "Add"
    add: "Toevoegen",
    // "Add New"
    addNew: "Nieuwe toevoegen",
    // "Click to add an item..."
    addItem: "Klik om een item toe te voegen...",
    // [Auto-translated] "Click to remove the item..."
    removeItem: "Klik om het item te verwijderen...",
    // [Auto-translated] "Drag the item"
    dragItem: "Sleep het item",
    // "Other"
    addOther: "Andere",
    // "Select All"
    addSelectAll: "Selecteer alles",
    // "None"
    addNone: "Geen",
    // "Remove All"
    removeAll: "Verwijder alles",
    // "Edit"
    edit: "Bewerk",
    // "Return without saving"
    back: "Keer terug zonder op te slaan",
    // "Return without saving"
    backTooltip: "Keer terug zonder op te slaan",
    // "Save and return"
    saveAndBack: "Bewaar en keer terug",
    // "Save and return"
    saveAndBackTooltip: "Bewaar en keer terug",
    // [Auto-translated] "Done"
    doneEditing: "Klaar",
    // "Edit Choices"
    editChoices: "Keuzes bewerken",
    // "Show Choices"
    showChoices: "Toon keuzes",
    // "Move"
    move: "Bewegen",
    // "<empty>"
    empty: "<leeg>",
    // [Auto-translated] "Value is empty"
    emptyValue: "Waarde is leeg",
    // "Manual Entry"
    fastEntry: "Snelle toegang",
    // [Auto-translated] "Value '{0}' is not unique"
    fastEntryNonUniqueError: "Waarde '{0}' is niet uniek",
    // [Auto-translated] "Please limit the number of items from {0} to {1}"
    fastEntryChoicesCountError: "Beperk het aantal objecten van {0} tot {1}",
    // [Auto-translated] "Please enter at least {0} items"
    fastEntryChoicesMinCountError: "Voer ten minste {0} objecten in",
    // [Auto-translated] "Enter the list of choice options and their IDs in the following format:\n\nid|option\n\nA choice option ID is not visible to respondents and can be used in conditional rules."
    fastEntryPlaceholder: "Voer de lijst met keuzeopties en hun ID's in de volgende indeling in:\n\nid|optie\n\nEen keuzeoptie-id is niet zichtbaar voor respondenten en kan worden gebruikt in voorwaardelijke regels.",
    // "Form Entry"
    formEntry: "Formulierinvoer",
    // "Test the service"
    testService: "Test de service",
    // "Please select the element"
    itemSelectorEmpty: "Selecteer het element",
    // "Please select the action"
    conditionActionEmpty: "Selecteer de actie",
    // "Select a question..."
    conditionSelectQuestion: "Selecteer vraag...",
    // "Select a page..."
    conditionSelectPage: "Selecteer pagina...",
    // "Select a panel..."
    conditionSelectPanel: "Selecteer paneel...",
    // "Please enter/select the value"
    conditionValueQuestionTitle: "Voer/selecteer de waarde",
    // "Press ctrl+space to get expression completion hint"
    aceEditorHelp: "Druk op Ctrl+spatiebalk om een hint voor het voltooien van een uitdrukking te krijgen",
    // "Current row"
    aceEditorRowTitle: "Huidige rij",
    // "Current panel"
    aceEditorPanelTitle: "Huidig paneel",
    // "For more details please check the documentation"
    showMore: "Raadpleeg de documentatie voor meer details",
    // "Available questions"
    assistantTitle: "Beschikbare vragen:",
    // "There is should be at least one column or row"
    cellsEmptyRowsColumns: "Er moet minimaal één kolom of rij zijn",
    // "Review before submit"
    showPreviewBeforeComplete: "Voorbeeldweergave voor afronden",
    // [Auto-translated] "Enabled by a condition"
    overridingPropertyPrefix: "Ingeschakeld door een voorwaarde",
    // [Auto-translated] "Reset"
    resetToDefaultCaption: "Terugstellen",
    // "Please enter a value"
    propertyIsEmpty: "Voer alstublieft een waarde in",
    // [Auto-translated] "Please enter a unique value"
    propertyIsNoUnique: "Voer een unieke waarde in",
    // "Please enter a unique name"
    propertyNameIsNotUnique: "Voer een unieke naam in",
    // "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\"."
    propertyNameIsIncorrect: "Gebruik geen gereserveerde woorden: \"item\", \"keuze\", \"paneel\", \"rij\".",
    // "You don't have any items yet"
    listIsEmpty: "Voeg een nieuw item toe",
    // [Auto-translated] "You don't have any choices yet"
    "listIsEmpty@choices": "Je hebt nog geen keuze",
    // [Auto-translated] "You don't have any columns yet"
    "listIsEmpty@columns": "Je hebt nog geen kolommen",
    // [Auto-translated] "You don't have layout columns yet"
    "listIsEmpty@gridLayoutColumns": "Je hebt nog geen lay-outkolommen",
    // [Auto-translated] "You don't have any rows yet"
    "listIsEmpty@rows": "Je hebt nog geen rijen",
    // [Auto-translated] "You don't have any validation rules yet"
    "listIsEmpty@validators": "Je hebt nog geen validatieregels",
    // [Auto-translated] "You don't have any custom variables yet"
    "listIsEmpty@calculatedValues": "Je hebt nog geen aangepaste variabelen",
    // [Auto-translated] "You don't have any triggers yet"
    "listIsEmpty@triggers": "Je hebt nog geen triggers",
    // [Auto-translated] "You don't have any links yet"
    "listIsEmpty@navigateToUrlOnCondition": "Je hebt nog geen links",
    // [Auto-translated] "You don't have any pages yet"
    "listIsEmpty@pages": "Je hebt nog geen pagina's",
    // [Auto-translated] "Add new choice"
    "addNew@choices": "Nieuwe keuze toevoegen",
    // [Auto-translated] "Add new column"
    "addNew@columns": "Nieuwe kolom toevoegen",
    // [Auto-translated] "Add new row"
    "addNew@rows": "Nieuwe rij toevoegen",
    // [Auto-translated] "Add new rule"
    "addNew@validators": "Nieuwe regel toevoegen",
    // [Auto-translated] "Add new variable"
    "addNew@calculatedValues": "Nieuwe variabele toevoegen",
    // [Auto-translated] "Add new trigger"
    "addNew@triggers": "Nieuwe trigger toevoegen",
    // [Auto-translated] "Add new URL"
    "addNew@navigateToUrlOnCondition": "Nieuwe URL toevoegen",
    // [Auto-translated] "Add new page"
    "addNew@pages": "Nieuwe pagina toevoegen",
    // "Expression is empty"
    expressionIsEmpty: "Expressie is leeg",
    // "Value"
    value: "Waarde",
    // "Text"
    text: "Tekst",
    // "Row ID"
    rowid: "Rij-ID",
    // "Image or video file URL"
    imageLink: "Afbeeldingslink",
    // "Edit column: {0}"
    columnEdit: "Kolom bewerken: {0}",
    // "Edit item: {0}"
    itemEdit: "Bewerk item: {0}",
    // "URL"
    url: "URL",
    // "Path to data"
    path: "Pad",
    choicesbyurl: {
      // [Auto-translated] "Web service URL"
      url: "URL van de webservice",
      // [Auto-translated] "Get value to store from the following property"
      valueName: "Haal waarde op om op te slaan uit de volgende eigenschap"
    },
    // "Get value to display from the following property"
    titleName: "Titel",
    // [Auto-translated] "Get file URLs from the following property"
    imageLinkName: "Bestands-URL's ophalen van de volgende eigenschap",
    // "Accept empty response"
    allowEmptyResponse: "Leeg respons toestaan",
    // "Title"
    titlePlaceholder: "Voer hier de titel in",
    // "Survey Title"
    surveyTitlePlaceholder: "Voer de enquêtetitel hier in",
    // "Page {num}"
    pageTitlePlaceholder: "Voer hier de paginatitel in",
    // [Auto-translated] "Start Page"
    startPageTitlePlaceholder: "Startpagina",
    // "Description"
    descriptionPlaceholder: "Voer een omschrijving in",
    // "Description"
    surveyDescriptionPlaceholder: "Voer een onderzoeksbeschrijving in",
    // "Description"
    pageDescriptionPlaceholder: "Voer een paginabeschrijving in",
    // [Auto-translated] "Wrap choices"
    textWrapEnabled: "Wrap-keuzes",
    // "Enable the \"Other\" option"
    showOtherItem: "De optie 'Anders' tonen",
    // "Rename the \"Other\" option"
    otherText: "Titel 'Anders:'-optie",
    // "Enable the \"None\" option"
    showNoneItem: "De optie 'Geen' tonen",
    // [Auto-translated] "Enable the \"Refuse to Answer\" option"
    showRefuseItem: "Schakel de optie \"Weigeren te antwoorden\" in",
    // [Auto-translated] "Enable the \"Don't Know\" option"
    showDontKnowItem: "Schakel de optie \"Niet weten\" in",
    // "Rename the \"None\" option"
    noneText: "Titel 'Geen'-optie",
    // "Enable the \"Select All\" option"
    showSelectAllItem: "Heeft de 'Alles selecteren'-optie",
    // "Rename the \"Select All\" option"
    selectAllText: "Titel 'Alles selecteren'-optie",
    // "Minimum value for auto-generated items"
    choicesMin: "Minimumwaarde voor automatisch gegenereerde items",
    // "Maximum value for auto-generated items"
    choicesMax: "Maximale waarde voor automatisch gegenereerde items",
    // "Step value for auto-generated items"
    choicesStep: "Het verschil tussen automatisch gegenereerde items",
    // "Name"
    name: "Naam",
    // "Title"
    title: "Titel",
    // "Cell input type"
    cellType: "Celtype",
    // "Column count"
    colCount: "Kolom tellen",
    // "Choice order"
    choicesOrder: "Volgorde opties",
    // [Auto-translated] "Allow custom choices"
    allowCustomChoices: "Aangepaste keuzes toestaan",
    // "Visible"
    visible: "Is zichtbaar?",
    // "Required"
    isRequired: "Is verplicht?",
    // [Auto-translated] "Mark as required"
    markRequired: "Markeren zoals vereist",
    // [Auto-translated] "Remove the required mark"
    removeRequiredMark: "Verwijder de vereiste markering",
    // "Require an answer in each row"
    eachRowRequired: "Antwoord vereisen voor alle rijen",
    // [Auto-translated] "Prevent duplicate responses in rows"
    eachRowUnique: "Voorkom dubbele antwoorden in rijen",
    // "Error message for required questions"
    requiredErrorText: "Tekst bij niet-ingevulde verplichte vraag",
    // "Display the question on a new line"
    startWithNewLine: "Beginnen met een nieuwe regel?",
    // "Rows"
    rows: "Aantal rijen",
    // "Columns"
    cols: "Kolom tellen",
    // "Placeholder text within input field"
    placeholder: "Hulptekst",
    // "Show preview area"
    showPreview: "Toon voorbeeldgebied",
    // "Store file content in JSON result as text"
    storeDataAsText: "Bewaar bestandsinhoud in JSON-resultaat als tekst",
    // "Maximum file size (in bytes)"
    maxSize: "Maximale bestandsgrootte in bytes",
    // [Auto-translated] "Maximum number of files"
    maxFiles: "Maximaal aantal bestanden",
    // "Row count"
    rowCount: "Aantal rijen",
    // "Columns layout"
    columnLayout: "Kolommen layout",
    // "\"Add Row\" button alignment"
    addRowButtonLocation: "Voeg de locatie van de rijknop toe",
    // [Auto-translated] "Transpose rows to columns"
    transposeData: "Rijen transponeren naar kolommen",
    // "\"Add Row\" button text"
    addRowText: "Voeg tekst van de rijknop toe",
    // "\"Remove Row\" button text"
    removeRowText: "Verwijder de tekst van de rijknop",
    // [Auto-translated] "Input field title pattern"
    singleInputTitleTemplate: "Titelpatroon invoerveld",
    // "Minimum rating value"
    rateMin: "Minimumtarief",
    // "Maximum rating value"
    rateMax: "Maximaal tarief",
    // "Step value"
    rateStep: "Beoordeel stap",
    // "Minimum value label"
    minRateDescription: "Beschrijving minimumtarief",
    // "Maximum value label"
    maxRateDescription: "Maximale tariefomschrijving",
    // "Input type"
    inputType: "Invoertype",
    // "Default Answer"
    defaultValue: "Standaardwaarde",
    // "Default texts"
    cellsDefaultRow: "Standaard celteksten",
    // "Edit survey settings"
    surveyEditorTitle: "Bewerk enquête-instellingen",
    // "Edit: {0}"
    qEditorTitle: "Bewerken: {0}",
    // "Maximum character limit"
    maxLength: "Maximale lengte",
    // "Build"
    buildExpression: "Bouwen",
    // "Edit"
    editExpression: "Bewerk",
    // [Auto-translated] "and"
    and: "en",
    // [Auto-translated] "or"
    or: "of",
    // "Remove"
    remove: "Verwijderen",
    // "Add Condition"
    addCondition: "Voorwaarde toevoegen",
    // [Auto-translated] "Select a question to start configuring conditions."
    emptyLogicPopupMessage: "Selecteer een vraag om te beginnen met het configureren van voorwaarden.",
    // [Auto-translated] "If"
    if: "Als",
    // [Auto-translated] "then"
    then: "dan",
    // [Auto-translated] "Target question"
    setToName: "Doelvraag",
    // [Auto-translated] "Question to copy answer from"
    fromName: "Vraag om het antwoord van te kopiëren",
    // [Auto-translated] "Question to skip to"
    gotoName: "Vraag om naar over te slaan",
    // [Auto-translated] "Rule is incorrect"
    ruleIsNotSet: "Regel is onjuist",
    // [Auto-translated] "Add to the survey results"
    includeIntoResult: "Toevoegen aan de enquêteresultaten",
    // "Make the title and description visible"
    showTitle: "Titel weergeven/verbergen",
    // "Expand/collapse title"
    expandCollapseTitle: "Titel uitvouwen/samenvouwen",
    // "Select a survey language"
    locale: "Standaardtaal",
    // "Select device type"
    simulator: "Kies apparaat",
    // "Switch to landscape orientation"
    landscapeOrientation: "Landschap",
    // [Auto-translated] "Switch to portrait orientation"
    portraitOrientation: "Overschakelen naar staande stand",
    // "Clear hidden question values"
    clearInvisibleValues: "Wis onzichtbare waarden",
    // "Limit to one response"
    cookieName: "Cookienaam (zodat enquête slechts éénmalig wordt ingevuld)",
    // "Auto-save survey progress on page change"
    partialSendEnabled: "Antwoorden opslaan bij pagina-overgang",
    // "Save the \"Other\" option value as a separate property"
    storeOthersAsComment: "Sla de waarde van 'anderen' op in een apart veld",
    // "Show page titles"
    showPageTitles: "Toon paginatitels",
    // "Show page numbers"
    showPageNumbers: "Toon paginanummers",
    // "\"Previous Page\" button text"
    pagePrevText: "Knoptitel 'Vorige pagina'",
    // "\"Next Page\" button text"
    pageNextText: "Knoptitel 'Volgende pagina'",
    // "\"Complete Survey\" button text"
    completeText: "Knoptitel 'Afronden'",
    // "\"Review Answers\" button text"
    previewText: "Knoptitel 'Voorbeeldweergave'",
    // "\"Edit Answer\" button text"
    editText: "Knoptitel 'Bewerken'",
    // "\"Start Survey\" button text"
    startSurveyText: "Knoptitel 'Starten'",
    // "Show navigation buttons"
    showNavigationButtons: "Navigatieknoppen weergeven (standaardnavigatie)",
    // [Auto-translated] "Navigation buttons alignment"
    navigationButtonsLocation: "Uitlijning van navigatieknoppen",
    // "Show the \"Previous Page\" button"
    showPrevButton: "Toon knop 'Vorige pagina' (gebruiker kan terugkeren)",
    // "First page is a start page"
    firstPageIsStartPage: "De eerste pagina in de enquête is een startpagina",
    // "Show the \"Thank You\" page"
    showCompletePage: "Toon bij afronden deze HTML-code",
    // "Auto-advance to the next page"
    autoAdvanceEnabled: "Na alle vragen automatisch naar volgende pagina gaan",
    // [Auto-translated] "Complete the survey automatically"
    autoAdvanceAllowComplete: "Vul de enquête automatisch in",
    // "Show the progress bar"
    showProgressBar: "Toon voortgangsbalk",
    // [Auto-translated] "Progress bar alignment"
    progressBarLocation: "Uitlijning van de voortgangsbalk",
    // "Question title alignment"
    questionTitleLocation: "Plek vraagtitel",
    // "Question title width"
    questionTitleWidth: "Breedte van de vraagtitel",
    // "Required symbol(s)"
    requiredMark: "Symbool(en) verplichte vraag",
    // "Question title template, default is: '{no}. {require} {title}'"
    questionTitleTemplate: "Vraagtitelsjabloon, standaard is: '{no}. {vereisen} {titel}'",
    // "Error message alignment"
    questionErrorLocation: "Plek vraagfoutmelding",
    // "Focus first question on a new page"
    autoFocusFirstQuestion: "Op volgende pagina focus op de eerste vraag zetten",
    // "Question order"
    questionOrder: "Volgorde elementen op pagina",
    // "Time limit to complete the survey"
    timeLimit: "Maximale tijd om de enquête te voltooien",
    // "Time limit to complete one page"
    timeLimitPerPage: "Maximale tijd om een pagina in de enquête te voltooien",
    // [Auto-translated] "Use a timer"
    showTimer: "Gebruik een timer",
    // "Timer alignment"
    timerLocation: "Toon timerpaneel",
    // "Timer mode"
    timerInfoMode: "Modus timerpaneel",
    // "Enable entry addition"
    allowAddPanel: "Sta het toevoegen van een paneel toe",
    // "Enable entry removal"
    allowRemovePanel: "Laat het verwijderen van het paneel toe",
    // "\"Add Entry\" button text"
    addPanelText: "Paneeltekst toevoegen",
    // "\"Remove Entry\" button text"
    removePanelText: "Paneeltekst verwijderen",
    // "Show all elements on one page"
    isSinglePage: "Toon alle elementen op één pagina",
    // "HTML markup"
    html: "Html",
    // [Auto-translated] "Answer"
    setValue: "Antwoorden",
    // [Auto-translated] "Storage format"
    dataFormat: "Opslag formaat",
    // [Auto-translated] "Enable row addition"
    allowAddRows: "Rij toevoegen inschakelen",
    // [Auto-translated] "Enable row removal"
    allowRemoveRows: "Rij verwijderen inschakelen",
    // [Auto-translated] "Enable row reordering"
    allowRowReorder: "Rij herschikken inschakelen",
    // [Auto-translated] "Does not apply if you specify the exact display area width or height."
    responsiveImageSizeHelp: "Is niet van toepassing als u de exacte breedte of hoogte van het weergavegebied opgeeft.",
    // [Auto-translated] "Minimum display area width"
    minImageWidth: "Minimale breedte van het weergavegebied",
    // [Auto-translated] "Maximum display area width"
    maxImageWidth: "Maximale breedte van het weergavegebied",
    // [Auto-translated] "Minimum display area height"
    minImageHeight: "Minimale hoogte van het weergavegebied",
    // [Auto-translated] "Maximum display area height"
    maxImageHeight: "Maximale hoogte van het weergavegebied",
    // "Minimum value"
    minValue: "Minimale waarde",
    // "Maximum value"
    maxValue: "Maximale waarde",
    // [Auto-translated] "Case insensitive"
    caseInsensitive: "Hoofdlettergevoelig",
    // "Minimum length (in characters)"
    minLength: "Minimale lengte",
    // "Allow digits"
    allowDigits: "Cijfers toestaan",
    // "Minimum count"
    minCount: "Minimum aantal",
    // "Maximum count"
    maxCount: "Maximale telling",
    // "Regular expression"
    regex: "Reguliere expressie",
    surveyvalidator: {
      // [Auto-translated] "Notification message for invalid input"
      text: "Melding voor ongeldige invoer",
      // [Auto-translated] "Valid when"
      expression: "Geldig wanneer",
      // [Auto-translated] "Notification type"
      notificationType: "Type melding",
      // [Auto-translated] "Maximum length (in characters)"
      maxLength: "Maximale lengte (in tekens)"
    },
    // "Total row header"
    totalText: "Totale tekst",
    // "Aggregation method"
    totalType: "Totaal type",
    // "Total value expression"
    totalExpression: "Totale expressie",
    // "Total value display format"
    totalDisplayStyle: "Totale weergavestijl",
    // "Currency"
    totalCurrency: "Totale valuta",
    // "Formatted string"
    totalFormat: "Totaal formaat",
    // [Auto-translated] "Survey logo"
    logo: "Enquête logo",
    // [Auto-translated] "Survey layout"
    questionsOnPageMode: "Enquête lay-out",
    // "Restrict answer length"
    maxTextLength: "Maximale tekstlengte",
    // "Restrict comment length"
    maxCommentLength: "Maximale tekstlengte optie 'Anders:'",
    // [Auto-translated] "Comment area height (in lines)"
    commentAreaRows: "Hoogte commentaargebied (in lijnen)",
    // [Auto-translated] "Auto-expand text areas"
    autoGrowComment: "Tekstgebieden automatisch uitvouwen",
    // [Auto-translated] "Allow users to resize text areas"
    allowResizeComment: "Gebruikers toestaan het formaat van tekstgebieden te wijzigen",
    // "Update input field values"
    textUpdateMode: "Modus tekstvernieuwing",
    // [Auto-translated] "Input mask type"
    maskType: "Type invoermasker",
    // "Set focus on the first invalid answer"
    autoFocusFirstError: "Focus op eerste fout zetten",
    // [Auto-translated] "Run validation"
    checkErrorsMode: "Validatie uitvoeren",
    // [Auto-translated] "Validate empty fields on lost focus"
    validateVisitedEmptyFields: "Lege velden valideren bij verloren focus",
    // [Auto-translated] "Redirect to an external link after submission"
    navigateToUrl: "Omleiden naar een externe link na indiening",
    // [Auto-translated] "Dynamic external link"
    navigateToUrlOnCondition: "Dynamische externe link",
    // [Auto-translated] "Markup to show if the user already filled out this survey"
    completedBeforeHtml: "Markering om aan te geven of de gebruiker deze enquête al heeft ingevuld",
    // [Auto-translated] "\"Thank You\" page markup"
    completedHtml: "\"Bedankt\" pagina opmaak",
    // [Auto-translated] "Dynamic \"Thank You\" page markup"
    completedHtmlOnCondition: "Dynamische opmaak van de pagina \"Bedankt\"",
    // [Auto-translated] "Markup to show while survey model is loading"
    loadingHtml: "Markeringen om weer te geven terwijl het enquêtemodel wordt geladen",
    // [Auto-translated] "Comment area text"
    commentText: "Tekst in het commentaargebied",
    // [Auto-translated] "Autocomplete type"
    autocomplete: "Type Automatisch aanvullen",
    // "Label for \"True\""
    labelTrue: "Label \"Waar\"",
    // "Label for \"False\""
    labelFalse: "Label 'Onwaar'",
    // "Show the Clear button"
    allowClear: "De knop Wissen weergeven",
    // [Auto-translated] "Search mode"
    searchMode: "Zoekmodus",
    // [Auto-translated] "Display format"
    displayStyle: "Weergave formaat",
    // [Auto-translated] "Formatted string"
    format: "Opgemaakte tekenreeks",
    // [Auto-translated] "Maximum fractional digits"
    maximumFractionDigits: "Maximum fractionele cijfers",
    // [Auto-translated] "Minimum fractional digits"
    minimumFractionDigits: "Minimale fractionele cijfers",
    // [Auto-translated] "Display grouping separators"
    useGrouping: "Scheidingstekens voor groeperingen weergeven",
    // [Auto-translated] "Enable multiple file upload"
    allowMultiple: "Uploaden van meerdere bestanden inschakelen",
    // [Auto-translated] "Preview uploaded images"
    allowImagesPreview: "Bekijk een voorbeeld van geüploade afbeeldingen",
    // [Auto-translated] "Accepted file categories"
    acceptedCategories: "Geaccepteerde bestandscategorieën",
    // [Auto-translated] "Additional file extensions"
    acceptedTypes: "Extra bestandsextensies",
    // [Auto-translated] "Wait for upload to complete"
    waitForUpload: "Wacht tot het uploaden is voltooid",
    // [Auto-translated] "Confirm file deletion"
    needConfirmRemoveFile: "Bevestig het verwijderen van bestanden",
    // [Auto-translated] "Row details alignment"
    detailPanelMode: "Uitlijning van rijdetails",
    // [Auto-translated] "Minimum row count"
    minRowCount: "Minimaal aantal rijen",
    // [Auto-translated] "Maximum row count"
    maxRowCount: "Maximaal aantal rijen",
    // "Confirm row removal"
    confirmDelete: "Rijverwijdering bevestigen",
    // [Auto-translated] "Confirmation message"
    confirmDeleteText: "Bevestigingsbericht",
    // [Auto-translated] "Initial number of entries"
    panelCount: "Initieel aantal inzendingen",
    // [Auto-translated] "Minimum number of entries"
    minPanelCount: "Minimum aantal inzendingen",
    // [Auto-translated] "Maximum number of entries"
    maxPanelCount: "Maximaal aantal inzendingen",
    // [Auto-translated] "Initial entry state"
    panelsState: "Status van eerste binnenkomst",
    // [Auto-translated] "\"Previous Entry\" button text"
    prevPanelText: "Tekst van de knop \"Vorige invoer\"",
    // [Auto-translated] "\"Next Entry\" button text"
    nextPanelText: "Tekst van de knop \"Volgende invoer\"",
    // [Auto-translated] "\"Remove Entry\" button alignment"
    removePanelButtonLocation: "Uitlijning van de knop \"Invoer verwijderen\"",
    // [Auto-translated] "Hide the question if it has no rows"
    hideIfRowsEmpty: "Verberg de vraag als deze geen rijen heeft",
    // [Auto-translated] "Hide columns if there are no rows"
    hideColumnsIfEmpty: "Kolommen verbergen als er geen rijen zijn",
    // [Auto-translated] "Custom rating values"
    rateValues: "Aangepaste beoordelingswaarden",
    // [Auto-translated] "Rating count"
    rateCount: "Aantal beoordelingen",
    // [Auto-translated] "Rating configuration"
    autoGenerate: "Classificatie configuratie",
    slider: {
      // [Auto-translated] "Min value"
      min: "Minimale waarde",
      // [Auto-translated] "Max value"
      max: "Maximale waarde",
      // [Auto-translated] "Step value"
      step: "Stap waarde",
      // [Auto-translated] "Show scale labels"
      showLabels: "Schaallabels weergeven",
      // [Auto-translated] "Show tooltips"
      tooltipVisibility: "Toon tooltips",
      // [Auto-translated] "Allow thumb crossing"
      allowSwap: "Duimkruising toestaan",
      // [Auto-translated] "Number of auto-generated labels"
      labelCount: "Aantal automatisch gegenereerde labels",
      // [Auto-translated] "Min value expression"
      minValueExpression: "Minimale waarde-expressie",
      // [Auto-translated] "Max value expression"
      maxValueExpression: "Maximale waarde expressie",
      // [Auto-translated] "Scale labels configuration"
      autoGenerate: "Configuratie van schaallabels",
      // [Auto-translated] "Slider type"
      sliderType: "Type schuifregelaar",
      // [Auto-translated] "Min range length"
      minRangeLength: "Min. bereik lengte",
      // [Auto-translated] "Max range length"
      maxRangeLength: "Maximale bereiklengte",
      // [Auto-translated] "Custom labels"
      customLabels: "Aangepaste labels",
      // [Auto-translated] "Label format"
      labelFormat: "Etiket formaat",
      // [Auto-translated] "Tooltip format"
      tooltipFormat: "Tooltip formaat"
    },
    file: {
      // [Auto-translated] "Image height"
      imageHeight: "Hoogte afbeelding",
      // [Auto-translated] "Image width"
      imageWidth: "Breedte afbeelding"
    },
    // [Auto-translated] "Hide the question if it has no choices"
    hideIfChoicesEmpty: "Verberg de vraag als er geen keuzes in zitten",
    // "Minimum width"
    minWidth: "Minimale breedte (in css-geaccepteerde waarden)",
    // "Maximum width"
    maxWidth: "Maximale breedte (in css-geaccepteerde waarden)",
    // "Width"
    width: "Breedte (in CSS-geaccepteerde waarden)",
    // [Auto-translated] "Show column headers"
    showHeader: "Kolomkoppen weergeven",
    // [Auto-translated] "Show horizontal scrollbar"
    horizontalScroll: "Horizontale schuifbalk weergeven",
    // [Auto-translated] "Minimum column width"
    columnMinWidth: "Minimale kolombreedte",
    // [Auto-translated] "Row header width"
    rowTitleWidth: "Breedte van de koptekst",
    // "Value to store when \"True\" is selected"
    valueTrue: "Waarde 'Waar'",
    // "Value to store when \"False\" is selected"
    valueFalse: "Waarde 'Onwaar'",
    // "\"Value is below minimum\" error message"
    minErrorText: "Foutbericht 'Waarde is onder het minimum'",
    // "\"Value exceeds maximum\" error message"
    maxErrorText: "Foutbericht 'Waarde overschrijdt maximum'",
    // "\"Empty comment\" error message"
    otherErrorText: "Foutbericht 'Lege opmerking'",
    // "Error message for duplicate responses"
    keyDuplicationError: "Foutbericht 'Niet-unieke sleutelwaarde'",
    // [Auto-translated] "Minimum choices to select"
    minSelectedChoices: "Minimale keuzes om te selecteren",
    // [Auto-translated] "Maximum choices to select"
    maxSelectedChoices: "Maximale keuze om te selecteren",
    // "Logo width"
    logoWidth: "Breedte logo",
    // "Logo height"
    logoHeight: "Hoogte logo",
    // "Read-only"
    readOnly: "Alleen-lezen",
    // [Auto-translated] "Disable the read-only mode if"
    enableIf: "Schakel de alleen-lezen modus uit als",
    // "\"No rows\" message"
    noRowsText: "Bericht 'Geen rijen'",
    // [Auto-translated] "Separate special choices"
    separateSpecialChoices: "Aparte speciale keuzes",
    // [Auto-translated] "Copy choices from the following question"
    choicesFromQuestion: "Kopieer keuzes uit de volgende vraag",
    // [Auto-translated] "Which choice options to copy"
    choicesFromQuestionMode: "Welke keuzeopties u wilt kopiëren",
    // [Auto-translated] "Use values from the following matrix column or panel question as choice IDs"
    choiceValuesFromQuestion: "Gebruik waarden uit de volgende matrixkolom of paneelvraag als keuze-ID's",
    // [Auto-translated] "Use values from the following matrix column or panel question as choice texts"
    choiceTextsFromQuestion: "Gebruik waarden uit de volgende matrixkolom of paneelvraag als keuzeteksten",
    // [Auto-translated] "Display page titles in the progress bar"
    progressBarShowPageTitles: "Paginatitels weergeven in de voortgangsbalk",
    // [Auto-translated] "Display page numbers in the progress bar"
    progressBarShowPageNumbers: "Paginanummers weergeven in de voortgangsbalk",
    // [Auto-translated] "Add a comment box"
    showCommentArea: "Een opmerkingenveld toevoegen",
    // [Auto-translated] "Placeholder text for the comment box"
    commentPlaceholder: "Tijdelijke tekst voor het opmerkingenvak",
    // [Auto-translated] "Show the labels as extreme values"
    displayRateDescriptionsAsExtremeItems: "De labels weergeven als extreme waarden",
    // [Auto-translated] "Row order"
    rowOrder: "Rijvolgorde",
    // [Auto-translated] "Column layout"
    columnsLayout: "Kolomindeling",
    // [Auto-translated] "Nested column count"
    columnColCount: "Aantal geneste kolommen",
    // [Auto-translated] "Correct Answer"
    correctAnswer: "Juist antwoord",
    // [Auto-translated] "Default Values"
    defaultPanelValue: "Standaardwaarden",
    // [Auto-translated] "Cell Texts"
    cells: "Celteksten",
    // [Auto-translated] "Select a file or paste a file link..."
    fileInputPlaceholder: "Selecteer een bestand of plak een bestandslink...",
    // "Prevent duplicate responses in the following column"
    keyName: "Sleutelkolom",
    itemvalue: {
      // [Auto-translated] "Make the option visible if"
      visibleIf: "Maak de optie zichtbaar als",
      // [Auto-translated] "Make the option selectable if"
      enableIf: "Maak de optie selecteerbaar als"
    },
    "itemvalue@rows": {
      // [Auto-translated] "Make the row visible if"
      visibleIf: "Maak de rij zichtbaar als",
      // [Auto-translated] "Make the row editable if"
      enableIf: "De rij bewerkbaar maken als:"
    },
    imageitemvalue: {
      // "Alt text"
      text: "Alternatieve tekst"
    },
    // "Logo alignment"
    logoPosition: "Positie logo",
    // "Add logo..."
    addLogo: "Logo toevoegen...",
    // "Change logo..."
    changeLogo: "Logo wijzigen...",
    logoPositions: {
      // "Remove logo"
      none: "Logo verwijderen",
      // "Left"
      left: "Links",
      // "Right"
      right: "Rechtsaf",
      // "On the top"
      top: "Bovenop",
      // "In the bottom"
      bottom: "Onder aan"
    },
    // [Auto-translated] "Preview mode"
    previewMode: "Preview-modus",
    // [Auto-translated] "Enable grid layout"
    gridLayoutEnabled: "Rasterlay-out inschakelen",
    // [Auto-translated] "Grid columns"
    gridLayoutColumns: "Raster kolommen",
    // [Auto-translated] "Mask settings"
    maskSettings: "Masker-instellingen",
    // [Auto-translated] "Row details error message alignment"
    detailErrorLocation: "Uitlijning van foutberichten in rijen",
    // Creator tabs
    tabs: {
      panel: {
        // [Auto-translated] "Panel Layout"
        layout: "Paneel Lay-out"
      },
      // "General"
      general: "Algemeen",
      // "Options"
      fileOptions: "Opties",
      // "HTML Editor"
      html: "Html-editor",
      // "Columns"
      columns: "Kolommen",
      // "Rows"
      rows: "Rijen",
      // "Choice Options"
      choices: "Keuzes",
      // "Items"
      items: "Artikelen",
      // "Visible If"
      visibleIf: "Zichtbaar als",
      // "Editable If"
      enableIf: "Schakel If in",
      // "Required If"
      requiredIf: "Vereist als",
      // "Rating Values"
      rateValues: "Beoordeel waarden",
      // [Auto-translated] "Slider Settings"
      sliderSettings: "Instellingen voor schuifregelaars",
      // "Choices from a Web Service"
      choicesByUrl: "Keuzes van internet",
      // "Default Choices"
      matrixChoices: "Standaardkeuzes",
      // "Text Inputs"
      multipleTextItems: "Tekstinvoer",
      // "Numbering"
      numbering: "Nummering",
      // "Validators"
      validators: "Validators",
      // "Navigation"
      navigation: "Navigatie",
      // "Question Settings"
      question: "Vraag",
      // "Pages"
      pages: "Pagina's",
      // "Quiz Mode"
      timer: "Timer/Quiz",
      // "Calculated Values"
      calculatedValues: "Berekende waardes",
      // "Triggers"
      triggers: "Triggers",
      // "Title template"
      templateTitle: "Sjabloontitel",
      // "Totals"
      totals: "Totalen",
      // "Conditions"
      logic: "Logica",
      // [Auto-translated] "Input Mask Settings"
      mask: "Instellingen voor invoermasker",
      layout: {
        // [Auto-translated] "Panel Layout"
        panel: "Paneel lay-out",
        // [Auto-translated] "Layout"
        question: "Indeling",
        // [Auto-translated] "Layout"
        base: "Indeling"
      },
      // "Data"
      data: "Gegevens",
      // "Validation"
      validation: "Validatie",
      // "Individual Cell Texts"
      cells: "Cellen",
      // "\"Thank You\" Page"
      showOnCompleted: "Weergeven bij afronden",
      // "Logo in the Survey Header"
      logo: "Logo in enquêtetitel",
      // "Slider"
      slider: "Schuifregelaar",
      // [Auto-translated] "Expression"
      expression: "Uitdrukking",
      // [Auto-translated] "Question Settings"
      questionSettings: "Vraag-instellingen",
      // "Header"
      header: "Rubriek",
      // "Background"
      background: "Achtergrond",
      // "Appearance"
      appearance: "Uiterlijk",
      // [Auto-translated] "Accent colors"
      accentColors: "Accent kleuren",
      // [Auto-translated] "Surface background"
      surfaceBackground: "Oppervlakte achtergrond",
      // [Auto-translated] "Scaling"
      scaling: "Schalen",
      // "Others"
      others: "Anderen"
    },
    // "Edit property '{0}'"
    editProperty: "Eigenschap '{0}' bewerken",
    // "Items"
    items: "Items",
    // [Auto-translated] "Make choices visible if"
    choicesVisibleIf: "Maak keuzes zichtbaar als",
    // [Auto-translated] "Make choices selectable if"
    choicesEnableIf: "Maak keuzes selecteerbaar als",
    // [Auto-translated] "Make columns visible if"
    columnsEnableIf: "Maak kolommen zichtbaar als",
    // [Auto-translated] "Make rows visible if"
    rowsEnableIf: "Maak rijen zichtbaar als",
    // [Auto-translated] "Increase the inner indent"
    innerIndent: "Vergroot de binnenste inkeping",
    // [Auto-translated] "Use answers from the last entry as default"
    copyDefaultValueFromLastEntry: "Gebruik antwoorden van de laatste invoer als standaard",
    // "Please enter a value."
    enterNewValue: "Voer de waarde in.",
    // "There are no questions in the survey."
    noquestions: "Er is geen enkele vraag in de enquête.",
    // "Please create a trigger"
    createtrigger: "Maak een trigger",
    // "Press enter button to edit"
    titleKeyboardAdornerTip: "Druk op de enter-knop om te bewerken",
    // "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item"
    keyboardAdornerTip: "Druk op de enter-knop om het item te bewerken, druk op de delete-knop om het item te verwijderen, druk op alt plus pijl omhoog of pijl omlaag om item te verplaatsen",
    // "On "
    triggerOn: "Aan ",
    // "Make pages visible"
    triggerMakePagesVisible: "Maak pagina's zichtbaar:",
    // "Make elements visible"
    triggerMakeQuestionsVisible: "Maak elementen zichtbaar:",
    // "Complete the survey if successful."
    triggerCompleteText: "Vul de enquête in als dit lukt.",
    // "The trigger is not set"
    triggerNotSet: "De trigger is niet ingesteld",
    // "Run if"
    triggerRunIf: "Voer als",
    // "Change value of: "
    triggerSetToName: "Verander waarde van: ",
    // "Copy value from: "
    triggerFromName: "Waarde kopiëren van: ",
    // "Run this Expression"
    triggerRunExpression: "Voer deze expressie uit:",
    // "to: "
    triggerSetValue: "naar: ",
    // "Go to the question"
    triggerGotoName: "Ga naar de vraag:",
    // "Do not put the variable into the survey result."
    triggerIsVariable: "Zet de variabele niet in het onderzoeksresultaat.",
    // "Please enter a valid expression"
    triggerRunExpressionEmpty: "Voer een geldige uitdrukking in",
    // [Auto-translated] "Type expression here..."
    emptyExpressionPlaceHolder: "Typ hier expressie...",
    // "No file chosen"
    noFile: "Geen bestand gekozen",
    // [Auto-translated] "Clear hidden question values"
    clearIfInvisible: "Waarden voor verborgen vragen wissen",
    // [Auto-translated] "Store values in the following property"
    valuePropertyName: "Sla waarden op in de volgende woning",
    // [Auto-translated] "Enable search-as-you-type"
    searchEnabled: "Zoeken terwijl u typt inschakelen",
    // [Auto-translated] "Hide selected items"
    hideSelectedItems: "Geselecteerde items verbergen",
    // [Auto-translated] "Collapse the dropdown upon selection"
    closeOnSelect: "De vervolgkeuzelijst samenvouwen bij selectie",
    // [Auto-translated] "Vertical alignment within cells"
    verticalAlign: "Verticale uitlijning binnen cellen",
    // [Auto-translated] "Alternate row colors"
    alternateRows: "Alternatieve rijkleuren",
    // [Auto-translated] "Make columns visible if"
    columnsVisibleIf: "Maak kolommen zichtbaar als",
    // [Auto-translated] "Make rows visible if"
    rowsVisibleIf: "Maak rijen zichtbaar als",
    // [Auto-translated] "Placeholder text for the comment box"
    otherPlaceholder: "Tijdelijke tekst voor het opmerkingenvak",
    // [Auto-translated] "Placeholder text for Local file"
    filePlaceholder: "Tijdelijke tekst voor lokaal bestand",
    // [Auto-translated] "Placeholder text for Camera"
    photoPlaceholder: "Tijdelijke tekst voor camera",
    // [Auto-translated] "Placeholder text for Local file or Camera"
    fileOrPhotoPlaceholder: "Tijdelijke tekst voor lokaal bestand of camera",
    // [Auto-translated] "Rating icon"
    rateType: "Beoordeling icoon",
    // [Auto-translated] "Ex.: https://api.example.com/books"
    url_placeholder: "Vb.: https://api.example.com/books",
    // [Auto-translated] "Ex.: categories.fiction"
    path_placeholder: "Vb.: categories.fiction",
    // [Auto-translated] "Ex.: a)"
    questionStartIndex_placeholder: "Vb.: a)",
    // [Auto-translated] "Ex.: 6in"
    width_placeholder: "Bijv.: 6in",
    // [Auto-translated] "Ex.: 600px"
    minWidth_placeholder: "Bijv.: 600px",
    // [Auto-translated] "Ex.: 50%"
    maxWidth_placeholder: "Vb.: 50%",
    // "auto"
    imageHeight_placeholder: "Auto",
    // "auto"
    imageWidth_placeholder: "Auto",
    // [Auto-translated] "Ex.: 100px"
    itemTitleWidth_placeholder: "Bijv.: 100px",
    theme: {
      // [Auto-translated] "Theme"
      themeName: "Thema",
      // [Auto-translated] "Question appearance"
      isPanelless: "Weergave van de vraag",
      // [Auto-translated] "Background and corner radius"
      editorPanel: "Achtergrond en hoekradius",
      // [Auto-translated] "Background and corner radius"
      questionPanel: "Achtergrond en hoekradius",
      // [Auto-translated] "Accent color"
      primaryColor: "Accent kleur",
      // [Auto-translated] "Panel and question box opacity"
      panelBackgroundTransparency: "Dekking van paneel en vraagbox",
      // [Auto-translated] "Input element opacity"
      questionBackgroundTransparency: "Opaciteit van het invoerelement",
      // [Auto-translated] "Survey font size"
      fontSize: "Lettergrootte van enquête",
      // [Auto-translated] "Survey scale factor"
      scale: "Enquête schaalfactor",
      // [Auto-translated] "Corner radius"
      cornerRadius: "De straal van de hoek",
      // [Auto-translated] "Advanced mode"
      advancedMode: "Geavanceerde modus",
      // [Auto-translated] "Title font"
      pageTitle: "Titel lettertype",
      // [Auto-translated] "Description font"
      pageDescription: "Beschrijving lettertype",
      // [Auto-translated] "Title font"
      questionTitle: "Titel lettertype",
      // [Auto-translated] "Description font"
      questionDescription: "Beschrijving lettertype",
      // [Auto-translated] "Font"
      editorFont: "Lettertype",
      // [Auto-translated] "Opacity"
      backgroundOpacity: "Dekking", // Auto-generated string
      // [Auto-translated] "Survey font family"
      "--sjs-font-family": "Familie van enquêtelettertypen",
      // [Auto-translated] "Background color"
      "--sjs-general-backcolor-dim": "Achtergrondkleur",
      // [Auto-translated] "Accent background colors"
      "--sjs-primary-backcolor": "Accent achtergrondkleuren",
      // [Auto-translated] "Accent foreground colors"
      "--sjs-primary-forecolor": "Accent voorgrondkleuren",
      // [Auto-translated] "Error message colors"
      "--sjs-special-red": "Foutmelding kleuren",
      // [Auto-translated] "Shadow effects"
      "--sjs-shadow-small": "Schaduweffecten",
      // [Auto-translated] "Shadow effects"
      "--sjs-shadow-inner": "Schaduweffecten",
      // [Auto-translated] "Colors"
      "--sjs-border-default": "Kleuren"
    },
    "header@header": {
      // [Auto-translated] "View"
      headerView: "Bekijken",
      // [Auto-translated] "Logo alignment"
      logoPosition: "Uitlijning van het logo",
      // [Auto-translated] "Survey title font"
      surveyTitle: "Lettertype van de titel van de enquête",
      // [Auto-translated] "Survey description font"
      surveyDescription: "Lettertype voor enquêtebeschrijving",
      // [Auto-translated] "Survey title font"
      headerTitle: "Lettertype van de titel van de enquête",
      // [Auto-translated] "Survey description font"
      headerDescription: "Lettertype voor enquêtebeschrijving",
      // [Auto-translated] "Content area width"
      inheritWidthFrom: "Breedte inhoudsgebied",
      // [Auto-translated] "Text width"
      textAreaWidth: "Breedte van de tekst",
      // [Auto-translated] "Background color"
      backgroundColorSwitch: "Achtergrondkleur",
      // [Auto-translated] "Background image"
      backgroundImage: "Achtergrondafbeelding",
      // [Auto-translated] "Opacity"
      backgroundImageOpacity: "Dekking",
      // [Auto-translated] "Overlap"
      overlapEnabled: "Overlappen",
      // [Auto-translated] "Logo alignment"
      logoPositionX: "Uitlijning van het logo",
      // [Auto-translated] "Survey title alignment"
      titlePositionX: "Uitlijning van de titel van de enquête",
      // [Auto-translated] "Survey description alignment"
      descriptionPositionX: "Uitlijning van de enquêtebeschrijving"
    }
  },
  // Property values
  pv: {
    // [Auto-translated] "true"
    "true": "waar",
    // [Auto-translated] "false"
    "false": "vals",
    // [Auto-translated] "Local file"
    file: "Lokaal bestand",
    // [Auto-translated] "Camera"
    camera: "Fototoestel",
    // [Auto-translated] "Local file or Camera"
    "file-camera": "Lokaal bestand of camera",
    // "Inherit"
    inherit: "Erven",
    // "Visible"
    show: "Tonen",
    // "Hidden"
    hide: "Zich verstoppen",
    // "Inherit"
    default: "Standaard",
    // "Initial"
    initial: "Standaard",
    // "Random"
    random: "Willekeurig",
    // "Collapsed"
    collapsed: "Ingestort",
    // "Expanded"
    expanded: "Uitgebreid",
    // "None"
    none: "Geen",
    // "Ascending"
    asc: "Oplopend",
    // "Descending"
    desc: "Aflopend",
    // "Indeterminate"
    indeterminate: "Onbepaald",
    // [Auto-translated] "Selected"
    selected: "Uitverkoren",
    // [Auto-translated] "Unselected"
    unselected: "Geselecteerd",
    // [Auto-translated] "decimal"
    decimal: "decimaal",
    // [Auto-translated] "currency"
    currency: "valuta",
    // [Auto-translated] "percent"
    percent: "procent",
    // "First panel is expanded"
    firstExpanded: "Eerste uitgevouwen",
    // "Hide question numbers"
    off: "Uit",
    // "List"
    list: "Lijst",
    // [Auto-translated] "Carousel"
    carousel: "Carrousel",
    // [Auto-translated] "Tabs"
    tab: "Tabs",
    // "Panel navigator + Progress bar at the top"
    progressTop: "Voortgang top",
    // "Panel navigator + Progress bar at the bottom"
    progressBottom: "Voortgang bodem",
    // "Panel navigator + Progress bar at the top and bottom"
    progressTopBottom: "Voortgang top bodem",
    // "Horizontal"
    horizontal: "Horizontaal",
    // "Vertical"
    vertical: "Verticaal",
    // "Top"
    top: "Top",
    // "Bottom"
    bottom: "Beneden",
    // "Top and bottom"
    topBottom: "Top en beneden",
    // "Both"
    both: "Beide",
    // "Left"
    left: "Links",
    // "Right"
    right: "Rechts",
    // [Auto-translated] "Center"
    center: "Middelpunt",
    // [Auto-translated] "Left and right"
    leftRight: "Links en rechts",
    // [Auto-translated] "Middle"
    middle: "Midden",
    // [Auto-translated] "color"
    color: "Kleur",
    // [Auto-translated] "date"
    date: "datum",
    // [Auto-translated] "datetime"
    datetime: "datetime",
    // [Auto-translated] "datetime-local"
    "datetime-local": "datetime-lokaal",
    // [Auto-translated] "email"
    email: "E-mail",
    // [Auto-translated] "month"
    month: "maand",
    // [Auto-translated] "number"
    number: "getal",
    // [Auto-translated] "password"
    password: "wachtwoord",
    // [Auto-translated] "range"
    range: "bereik",
    // [Auto-translated] "tel"
    tel: "Tel",
    // "text"
    text: "Text",
    // [Auto-translated] "time"
    time: "Tijd",
    // [Auto-translated] "url"
    url: "Url",
    // [Auto-translated] "week"
    week: "week",
    // "Hidden"
    hidden: "Verborgen",
    // "Editable"
    edit: "Bewerk",
    // "Read-only"
    display: "Scherm",
    // [Auto-translated] "Contain"
    contain: "Bevatten",
    // [Auto-translated] "Cover"
    cover: "Bedekken",
    // [Auto-translated] "Fill"
    fill: "Vullen",
    // [Auto-translated] "Next"
    next: "Volgend",
    // [Auto-translated] "Last"
    last: "Laatste",
    // "Upon survey completion"
    onComplete: "Bij afronden",
    // "When question gets hidden"
    onHidden: "Bij verbergen",
    // [Auto-translated] "When question or its panel/page gets hidden"
    onHiddenContainer: "Wanneer de vraag of het paneel/de pagina ervan wordt verborgen",
    clearInvisibleValues: {
      // [Auto-translated] "Never"
      none: "Nooit"
    },
    clearIfInvisible: {
      // [Auto-translated] "Never"
      none: "Nooit"
    },
    // [Auto-translated] "Radio Buttons"
    radio: "Keuzerondjes",
    inputType: {
      // [Auto-translated] "Color"
      color: "Kleur",
      // [Auto-translated] "Date"
      date: "Datum",
      // [Auto-translated] "Date and Time"
      "datetime-local": "Datum en tijd",
      // [Auto-translated] "Email"
      email: "E-mail",
      // [Auto-translated] "Month"
      month: "Maand",
      // [Auto-translated] "Number"
      number: "Getal",
      // [Auto-translated] "Password"
      password: "Wachtwoord",
      // [Auto-translated] "Range"
      range: "Bereik",
      // [Auto-translated] "Phone Number"
      tel: "Telefoonnummer",
      // "Text"
      text: "Text",
      // [Auto-translated] "Time"
      time: "Tijd",
      // [Auto-translated] "URL"
      url: "Url",
      // [Auto-translated] "Week"
      week: "Week"
    },
    sliderType: {
      // [Auto-translated] "Single-Value"
      single: "Enkele waarde",
      // [Auto-translated] "Range"
      range: "Bereik"
    },
    tooltipVisibility: {
      // [Auto-translated] "Auto"
      auto: "Auto",
      // [Auto-translated] "Always"
      always: "Altijd",
      // [Auto-translated] "Never"
      never: "Nooit"
    },
    notificationType: {
      // [Auto-translated] "Error"
      error: "Fout",
      // [Auto-translated] "Warning"
      warning: "Waarschuwing",
      // [Auto-translated] "Informational"
      info: "Informatieve"
    },
    acceptedCategories: {
      // [Auto-translated] "Images"
      image: "Beelden",
      // [Auto-translated] "Videos"
      video: "Video 's",
      // [Auto-translated] "Audio"
      audio: "Audio",
      // [Auto-translated] "Documents"
      document: "Documenten",
      // [Auto-translated] "Archives"
      archive: "Archief",
      // [Auto-translated] "Custom"
      custom: "Gewoonte"
    },
    autocomplete: {
      // [Auto-translated] "Full Name"
      name: "Voor- en achternaam",
      // [Auto-translated] "Prefix"
      "honorific-prefix": "Voorvoegsel",
      // [Auto-translated] "First Name"
      "given-name": "Voornaam",
      // [Auto-translated] "Middle Name"
      "additional-name": "Middelste naam",
      // [Auto-translated] "Last Name"
      "family-name": "Achternaam",
      // [Auto-translated] "Suffix"
      "honorific-suffix": "Achtervoegsel",
      // [Auto-translated] "Nickname"
      nickname: "Bijnaam",
      // [Auto-translated] "Job Title"
      "organization-title": "Functietitel",
      // [Auto-translated] "User Name"
      username: "Gebruikersnaam",
      // [Auto-translated] "New Password"
      "new-password": "Nieuw wachtwoord",
      // [Auto-translated] "Current Password"
      "current-password": "Huidig wachtwoord",
      // [Auto-translated] "Organization Name"
      organization: "Naam van de organisatie",
      // [Auto-translated] "Full Street Address"
      "street-address": "Volledig adres",
      // [Auto-translated] "Address Line 1"
      "address-line1": "Adres Regel 1",
      // [Auto-translated] "Address Line 2"
      "address-line2": "Adres Regel 2",
      // [Auto-translated] "Address Line 3"
      "address-line3": "Adres Regel 3",
      // [Auto-translated] "Level 4 Address"
      "address-level4": "Niveau 4 Adres",
      // [Auto-translated] "Level 3 Address"
      "address-level3": "Niveau 3 Adres",
      // [Auto-translated] "Level 2 Address"
      "address-level2": "Niveau 2 Adres",
      // [Auto-translated] "Level 1 Address"
      "address-level1": "Niveau 1 Adres",
      // [Auto-translated] "Country Code"
      country: "Landcode",
      // [Auto-translated] "Country Name"
      "country-name": "Naam van het land",
      // [Auto-translated] "Postal Code"
      "postal-code": "Postcode",
      // [Auto-translated] "Cardholder Name"
      "cc-name": "Naam kaarthouder",
      // [Auto-translated] "Cardholder First Name"
      "cc-given-name": "Voornaam kaarthouder",
      // [Auto-translated] "Cardholder Middle Name"
      "cc-additional-name": "Middelste naam kaarthouder",
      // [Auto-translated] "Cardholder Last Name"
      "cc-family-name": "Achternaam kaarthouder",
      // [Auto-translated] "Credit Card Number"
      "cc-number": "Creditcardnummer",
      // [Auto-translated] "Expiration Date"
      "cc-exp": "Vervaldatum",
      // [Auto-translated] "Expiration Month"
      "cc-exp-month": "Vervaldatum maand",
      // [Auto-translated] "Expiration Year"
      "cc-exp-year": "Vervaldatum jaar",
      // [Auto-translated] "Card Security Code"
      "cc-csc": "Beveiligingscode van de kaart",
      // [Auto-translated] "Credit Card Type"
      "cc-type": "Type creditcard",
      // [Auto-translated] "Transaction Currency"
      "transaction-currency": "Valuta van de transactie",
      // [Auto-translated] "Transaction Amount"
      "transaction-amount": "Transactiebedrag",
      // [Auto-translated] "Preferred Language"
      language: "Voorkeurstaal",
      // [Auto-translated] "Birthday"
      bday: "Verjaardag",
      // [Auto-translated] "Birthday Day"
      "bday-day": "Verjaardag Dag",
      // [Auto-translated] "Birthday Month"
      "bday-month": "Verjaardag Maand",
      // [Auto-translated] "Birthday Year"
      "bday-year": "Verjaardag Jaar",
      // [Auto-translated] "Gender"
      sex: "Geslacht",
      // [Auto-translated] "Website URL"
      url: "Website URL",
      // [Auto-translated] "Profile Photo"
      photo: "Profielfoto",
      // [Auto-translated] "Telephone Number"
      tel: "Telefoonnummer",
      // [Auto-translated] "Country Code for Phone"
      "tel-country-code": "Landcode voor telefoon",
      // [Auto-translated] "National Telephone Number"
      "tel-national": "Nationaal telefoonnummer",
      // [Auto-translated] "Area Code"
      "tel-area-code": "Netnummer",
      // [Auto-translated] "Local Phone Number"
      "tel-local": "Lokaal telefoonnummer",
      // [Auto-translated] "Local Phone Prefix"
      "tel-local-prefix": "Lokaal telefoonvoorvoegsel",
      // [Auto-translated] "Local Phone Suffix"
      "tel-local-suffix": "Lokaal telefoonnummer achtervoegsel",
      // [Auto-translated] "Phone Extension"
      "tel-extension": "Telefoon extensie",
      // [Auto-translated] "Email Address"
      email: "E-mailadres",
      // [Auto-translated] "Instant Messaging Protocol"
      impp: "Instant Messaging Protocol"
    },
    maskType: {
      // [Auto-translated] "None"
      none: "Geen",
      // [Auto-translated] "Pattern"
      pattern: "Patroon",
      // [Auto-translated] "Numeric"
      numeric: "Numeriek",
      // [Auto-translated] "Date and Time"
      datetime: "Datum en tijd",
      // [Auto-translated] "Currency"
      currency: "Valuta"
    },
    inputTextAlignment: {
      // [Auto-translated] "Auto"
      auto: "Auto",
      // [Auto-translated] "Left"
      left: "Links",
      // [Auto-translated] "Right"
      right: "Rechts"
    },
    // "All"
    all: "Alle",
    // "Page"
    page: "Pagina",
    // "Survey"
    survey: "Enquête",
    // "When switching to the next page"
    onNextPage: "Bij pagina-overgang",
    // "After an answer is changed"
    onValueChanged: "Bij waardeverandering",
    // [Auto-translated] "Before an answer is changed"
    onValueChanging: "Voordat een antwoord wordt gewijzigd",
    questionsOnPageMode: {
      // [Auto-translated] "Original structure"
      standard: "Oorspronkelijke structuur",
      // [Auto-translated] "Show all questions on one page"
      singlePage: "Toon alle vragen op één pagina",
      // [Auto-translated] "Show single question per page"
      questionPerPage: "Toon één vraag per pagina",
      // [Auto-translated] "Show single input field per page"
      inputPerPage: "Toon enkel invoerveld per pagina"
    },
    // "No preview"
    noPreview: "Geen preview",
    // "Show all questions"
    showAllQuestions: "Toon voorbeeld met alle vragen",
    // "Show answered questions only"
    showAnsweredQuestions: "Toon voorbeeld met beantwoorde vragen",
    // [Auto-translated] "Show all questions"
    allQuestions: "Toon alle vragen",
    // [Auto-translated] "Show answered questions only"
    answeredQuestions: "Alleen beantwoorde vragen weergeven",
    // [Auto-translated] "Completed pages"
    pages: "Voltooide pagina's",
    // [Auto-translated] "Answered questions"
    questions: "Beantwoorde vragen",
    // [Auto-translated] "Answered required questions"
    requiredQuestions: "Vereiste vragen beantwoord",
    // [Auto-translated] "Valid answers"
    correctQuestions: "Geldige antwoorden",
    // [Auto-translated] "Completed pages (button UI)"
    buttons: "Voltooide pagina's (knop UI)",
    // "Under the input field"
    underInput: "Onder het invoerveld",
    // "Under the question title"
    underTitle: "Onder de titel",
    // "On lost focus"
    onBlur: "Bij verliezen focus",
    // "While typing"
    onTyping: "Tijdens het typen",
    // [Auto-translated] "Under the row"
    underRow: "Onder de rij",
    // [Auto-translated] "Under the row, display one section only"
    underRowSingle: "Geef onder de rij slechts één sectie weer",
    // "Auto"
    auto: "Auto",
    timerInfoMode: {
      // "Both"
      combined: "Beide"
    },
    addRowButtonLocation: {
      // [Auto-translated] "Based on matrix layout"
      default: "Gebaseerd op matrixlay-out"
    },
    panelsState: {
      // [Auto-translated] "Locked"
      default: "Op slot",
      // [Auto-translated] "Collapse all"
      collapsed: "Alles samenvouwen",
      // [Auto-translated] "Expand all"
      expanded: "Alles uitvouwen",
      // [Auto-translated] "First expanded"
      firstExpanded: "Eerst uitgebreid"
    },
    widthMode: {
      // [Auto-translated] "Static"
      static: "Statisch",
      // [Auto-translated] "Responsive"
      responsive: "Responsieve"
    },
    contentMode: {
      // [Auto-translated] "Image"
      image: "Beeld",
      // [Auto-translated] "Video"
      video: "Video",
      // [Auto-translated] "YouTube"
      youtube: "YouTube"
    },
    displayMode: {
      // [Auto-translated] "Buttons"
      buttons: "Knopen",
      // [Auto-translated] "Dropdown"
      dropdown: "Vervolgkeuzemenu"
    },
    rateColorMode: {
      // [Auto-translated] "Default"
      default: "Verstek",
      // [Auto-translated] "Scale"
      scale: "Schub"
    },
    scaleColorMode: {
      // [Auto-translated] "Monochrome"
      monochrome: "Monochroom",
      // [Auto-translated] "Colored"
      colored: "Gekleurd"
    },
    autoGenerate: {
      // [Auto-translated] "Auto-generate"
      "true": "Automatisch genereren",
      // [Auto-translated] "Manual"
      "false": "Handmatig"
    },
    rateType: {
      // [Auto-translated] "Labels"
      labels: "Etiketten",
      // [Auto-translated] "Stars"
      stars: "Sterren",
      // [Auto-translated] "Smileys"
      smileys: "Smileys"
    },
    state: {
      // [Auto-translated] "Locked"
      default: "Op slot"
    },
    showQuestionNumbers: {
      // [Auto-translated] "Auto-numbering"
      default: "Automatische nummering",
      // [Auto-translated] "Auto-numbering"
      on: "Automatische nummering",
      // [Auto-translated] "Reset on each page"
      onPage: "Reset op elke pagina",
      // [Auto-translated] "Reset on each panel"
      onpanel: "Reset op elk paneel",
      // [Auto-translated] "Reset on each panel"
      onPanel: "Reset op elk paneel",
      // [Auto-translated] "Recursive numbering"
      recursive: "Recursieve nummering",
      // [Auto-translated] "Continue across the survey"
      onSurvey: "Doorgaan in de enquête",
      // [Auto-translated] "No numbering"
      off: "Geen nummering"
    },
    descriptionLocation: {
      // [Auto-translated] "Under the question title"
      underTitle: "Onder de titel van de vraag",
      // [Auto-translated] "Under the input field"
      underInput: "Onder het invoerveld"
    },
    selectToRankAreasLayout: {
      // [Auto-translated] "Next to choices"
      horizontal: "Naast keuzes",
      // [Auto-translated] "Above choices"
      vertical: "Bovenstaande keuzes"
    },
    displayStyle: {
      // [Auto-translated] "Decimal"
      decimal: "Decimaal",
      // [Auto-translated] "Currency"
      currency: "Valuta",
      // [Auto-translated] "Percentage"
      percent: "Percentage",
      // [Auto-translated] "Date"
      date: "Datum"
    },
    totalDisplayStyle: {
      // [Auto-translated] "Decimal"
      decimal: "Decimaal",
      // [Auto-translated] "Currency"
      currency: "Valuta",
      // [Auto-translated] "Percentage"
      percent: "Percentage",
      // [Auto-translated] "Date"
      date: "Datum"
    },
    rowOrder: {
      // [Auto-translated] "Original"
      initial: "Origineel"
    },
    questionOrder: {
      // [Auto-translated] "Original"
      initial: "Origineel"
    },
    progressBarLocation: {
      // [Auto-translated] "Top"
      top: "Boven",
      // [Auto-translated] "Bottom"
      bottom: "Bodem",
      // [Auto-translated] "Top and bottom"
      topbottom: "Boven en onder",
      // [Auto-translated] "Above the header"
      aboveheader: "Boven de koptekst",
      // [Auto-translated] "Below the header"
      belowheader: "Onder de kop",
      // [Auto-translated] "Hidden"
      off: "Verborgen"
    },
    // [Auto-translated] "Sum"
    sum: "Som",
    // [Auto-translated] "Count"
    count: "Tellen",
    // [Auto-translated] "Min"
    min: "Min",
    // [Auto-translated] "Max"
    max: "Max",
    // [Auto-translated] "Avg"
    avg: "Avg",
    searchMode: {
      // [Auto-translated] "Contains"
      contains: "Bevat",
      // [Auto-translated] "Starts with"
      startsWith: "Begint met"
    },
    backgroundImageFit: {
      // [Auto-translated] "Auto"
      auto: "Auto",
      // [Auto-translated] "Cover"
      cover: "Bedekken",
      // [Auto-translated] "Contain"
      contain: "Bevatten",
      // [Auto-translated] "Stretch"
      fill: "Strekken",
      // [Auto-translated] "Tile"
      tile: "Tegel"
    },
    backgroundImageAttachment: {
      // [Auto-translated] "Fixed"
      fixed: "Vast",
      // [Auto-translated] "Scroll"
      scroll: "Scrollen"
    },
    headerView: {
      // [Auto-translated] "Basic"
      basic: "Basisch",
      // [Auto-translated] "Advanced"
      advanced: "Geavanceerd"
    },
    inheritWidthFrom: {
      // [Auto-translated] "Same as survey"
      survey: "Zelfde als enquête",
      // [Auto-translated] "Same as container"
      container: "Zelfde als container"
    },
    backgroundColorSwitch: {
      // [Auto-translated] "None"
      none: "Geen",
      // [Auto-translated] "Accent color"
      accentColor: "Accent kleur",
      // [Auto-translated] "Custom"
      custom: "Gewoonte"
    },
    colorPalette: {
      // [Auto-translated] "Light"
      light: "Licht",
      // [Auto-translated] "Dark"
      dark: "Donker"
    },
    isPanelless: {
      // [Auto-translated] "Default"
      "false": "Verstek",
      // [Auto-translated] "Without Panels"
      "true": "Zonder panelen"
    },
    progressBarInheritWidthFrom: {
      // [Auto-translated] "Same as survey"
      survey: "Zelfde als enquête",
      // [Auto-translated] "Same as container"
      container: "Zelfde als container"
    }
  },
  // Operators
  op: {
    // "Empty"
    empty: "is leeg",
    // "Not empty"
    notempty: "is niet leeg",
    // "Equals"
    equal: "gelijk is",
    // "Does not equal"
    notequal: "niet gelijk",
    // "Contains"
    contains: "bevat",
    // "Does not contain"
    notcontains: "bevat niet",
    // "Any of"
    anyof: "een van",
    // [Auto-translated] "None of"
    noneof: "Geen van",
    // "All of"
    allof: "alles van",
    // "Greater than"
    greater: "groter",
    // "Less than"
    less: "minder",
    // "Greater than or equal to"
    greaterorequal: "groter of gelijk aan",
    // "Less than or equal to"
    lessorequal: "minder of gelijk aan",
    // [Auto-translated] "and"
    and: "en",
    // [Auto-translated] "or"
    or: "of"
  },
  // Embed window
  ew: {
    // "Use Angular version"
    angular: "Gebruik de Angular-versie",
    // "Use jQuery version"
    jquery: "Gebruik de jQuery-versie",
    // "Use Knockout version"
    knockout: "Gebruik de Knockout-versie",
    // "Use React version"
    react: "Gebruik de React-versie",
    // "Use Vue version"
    vue: "Gebruik de Vue-versie",
    // "For bootstrap framework"
    bootstrap: "Voor bootstrap-framework",
    // "Modern theme"
    modern: "Modern thema",
    // "Default theme"
    default: "Standaard thema",
    // "Orange theme"
    orange: "Oranje thema",
    // "Darkblue theme"
    darkblue: "Donkerblauw thema",
    // "Darkrose theme"
    darkrose: "Donkereroos thema",
    // "Stone theme"
    stone: "Stenen thema",
    // "Winter theme"
    winter: "Winter thema",
    // "Winter-Stone theme"
    winterstone: "Wintersteen thema",
    // "Show survey on a page"
    showOnPage: "Toon enquête op een pagina",
    // "Show survey in a window"
    showInWindow: "Toon enquête in een venster",
    // "Load Survey JSON from server"
    loadFromServer: "Laad Survey JSON vanaf de server",
    // "Scripts and styles"
    titleScript: "Scripts en stijlen",
    // "HTML"
    titleHtml: "HTML",
    // "JavaScript"
    titleJavaScript: "JavaScript"
  },
  // Preview (Survey)
  ts: {
    // "Select the page to test it"
    selectPage: "Selecteer de pagina om deze te testen:",
    // "Show invisible elements"
    showInvisibleElements: "Toon onzichtbare elementen",
    // [Auto-translated] "Hide invisible elements"
    hideInvisibleElements: "Onzichtbare elementen verbergen",
    // [Auto-translated] "Previous"
    prevPage: "Vorig",
    // [Auto-translated] "Next"
    nextPage: "Volgend"
  },
  validators: {
    // "Answer count"
    answercountvalidator: "Aantal antwoorden",
    // "Email"
    emailvalidator: "E-mail",
    // "Expression"
    expressionvalidator: "Uitdrukking",
    // "Number"
    numericvalidator: "Numeriek",
    // "Regex"
    regexvalidator: "Regex",
    // "Text"
    textvalidator: "Tekst"
  },
  triggers: {
    // "Complete survey"
    completetrigger: "Volledige enquête",
    // "Set answer"
    setvaluetrigger: "Ingestelde waarde",
    // "Copy answer"
    copyvaluetrigger: "Kopie waarde",
    // "Skip to question"
    skiptrigger: "Ga naar de vraag",
    // "Run expression"
    runexpressiontrigger: "Run expressie",
    // "change visibility (deprecated)"
    visibletrigger: "Zichtbaarheid wijzigen (verouderd)"
  },
  peplaceholder: {
    patternmask: {
      // "Ex.: +1(999)-999-99-99"
      pattern: "Vb.: +1(999)-999-99-99"
    },
    datetimemask: {
      // "Ex.: mm/dd/yyyy HH:MM:ss"
      pattern: "Bijv.: mm/dd/jjjj"
    },
    currencymask: {
      // "Ex.: $"
      prefix: "Bijv.: $",
      // "Ex.: USD"
      suffix: "Bijv.: USD"
    },
    panelbase: {
      // [Auto-translated] "Ex.: 200px"
      questionTitleWidth: "Bijv.: 200px"
    },
    panellayoutcolumn: {
      // "Ex.: 30%"
      effectiveWidth: "Excl.: 30%",
      // "Ex.: 200px"
      questionTitleWidth: "Bijv.: 200px"
    }
  },
  pehelp: {
    panel: {
      // "A panel ID that is not visible to respondents."
      name: "Een panel-ID die niet zichtbaar is voor respondenten.",
      // [Auto-translated] "Type a panel subtitle."
      description: "Typ een deelvenster ondertiteling.",
      // "Use the magic wand icon to set a conditional rule that determines panel visibility."
      visibleIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de zichtbaarheid van het deelvenster bepaalt.",
      // [Auto-translated] "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel."
      enableIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de alleen-lezen modus voor het deelvenster uitschakelt.",
      // "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer."
      requiredIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft.",
      // [Auto-translated] "Applies to all questions within this panel. When set to \"Hidden\", it also hides question descriptions. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default). "
      questionTitleLocation: "Geldt voor alle vragen in dit panel. Als het is ingesteld op \"Verborgen\", worden ook vraagbeschrijvingen verborgen. Als u deze instelling wilt overschrijven, definieert u regels voor titeluitlijning voor afzonderlijke vragen. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Bovenaan\" standaard) toe. ",
      // [Auto-translated] "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)."
      questionTitleWidth: "Hiermee stelt u een consistente breedte in voor vraagtitels wanneer deze links van de vraagvakken zijn uitgelijnd. Accepteert CSS-waarden (px, %, in, pt, enz.).",
      // "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting."
      questionErrorLocation: "Hiermee stelt u de locatie van een foutmelding in met betrekking tot alle vragen in het panel. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe.",
      // [Auto-translated] "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting."
      questionOrder: "Behoudt de oorspronkelijke volgorde van vragen of maakt ze willekeurig. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe.",
      // "Repositions the panel to the end of a selected page."
      page: "Hiermee verplaatst u het deelvenster naar het einde van een geselecteerde pagina.",
      // [Auto-translated] "Adds space or margin between the panel content and the left border of the panel box."
      innerIndent: "Hiermee voegt u ruimte of marge toe tussen de inhoud van het deelvenster en de linkerrand van het deelvenstervak.",
      // "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form."
      startWithNewLine: "Schakel de optie uit om het deelvenster op één regel weer te geven met de vorige vraag of het vorige deelvenster. De instelling is niet van toepassing als het deelvenster het eerste element in uw formulier is.",
      // "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed."
      state: "Kies uit: \"Uitgevouwen\" - het paneel wordt volledig weergegeven en kan worden ingeklapt; \"Samengevouwen\" - het paneel toont alleen de titel en beschrijving en kan worden uitgevouwen; \"Vergrendeld\" - het paneel wordt volledig weergegeven en kan niet worden ingeklapt.",
      // [Auto-translated] "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)."
      width: "Hiermee stelt u de breedte van het deelvenster in verhouding tot andere meetelementen in dezelfde lijn. Accepteert CSS-waarden (px, %, %, in, pt, enz.).",
      // [Auto-translated] "Assigns numbers to questions nested within this panel."
      showQuestionNumbers: "Wijst nummers toe aan vragen die in dit deelvenster zijn genest.",
      // [Auto-translated] "Specifies how many columns this panel spans within the grid layout."
      effectiveColSpan: "Hiermee geeft u aan hoeveel kolommen dit deelvenster beslaat binnen de rasterlay-out.",
      // [Auto-translated] "This table lets you configure each grid column within the panel. It automatically sets the width percentage for each column based on the maximum number of elements in a row. To customize the grid layout, manually adjust these values and define the title width for all questions in each column."
      gridLayoutColumns: "Met deze tabel kunt u elke rasterkolom in het deelvenster configureren. Het stelt automatisch het breedtepercentage voor elke kolom in op basis van het maximale aantal elementen in een rij. Als u de rasterlay-out wilt aanpassen, past u deze waarden handmatig aan en definieert u de titelbreedte voor alle vragen in elke kolom."
    },
    paneldynamic: {
      // "A panel ID that is not visible to respondents."
      name: "Een panel-ID die niet zichtbaar is voor respondenten.",
      // "Type a panel subtitle."
      description: "Typ een ondertitel in het deelvenster.",
      // "Use the magic wand icon to set a conditional rule that determines panel visibility."
      visibleIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de zichtbaarheid van het deelvenster bepaalt.",
      // [Auto-translated] "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel."
      enableIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de alleen-lezen modus voor het deelvenster uitschakelt.",
      // "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer."
      requiredIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft.",
      // "Applies to all questions within this dynamic panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)."
      templateQuestionTitleLocation: "Geldt voor alle vragen binnen dit panel. Als u deze instelling wilt overschrijven, definieert u regels voor titeluitlijning voor afzonderlijke vragen. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Standaard bovenaan\") toe.",
      // "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)."
      templateQuestionTitleWidth: "Hiermee stelt u een consistente breedte in voor vraagtitels wanneer deze links van de vraagvakken zijn uitgelijnd. Accepteert CSS-waarden (px, %, %, in, pt, enz.).",
      // "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)."
      templateErrorLocation: "Hiermee stelt u de locatie in van een foutmelding met betrekking tot een vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Standaard bovenaan\") toe.",
      // "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting."
      errorLocation: "Hiermee stelt u de locatie van een foutmelding in met betrekking tot alle vragen in het panel. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe.",
      // "Repositions the panel to the end of a selected page."
      page: "Hiermee verplaatst u het deelvenster naar het einde van een geselecteerde pagina.",
      // [Auto-translated] "Adds space or margin between the panel content and the left border of the panel box."
      indent: "Hiermee voegt u ruimte of marge toe tussen de inhoud van het deelvenster en de linkerrand van het deelvenster.",
      // "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form."
      startWithNewLine: "Schakel de optie uit om het deelvenster op één regel weer te geven met de vorige vraag of het vorige deelvenster. De instelling is niet van toepassing als het deelvenster het eerste element in uw formulier is.",
      // "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed."
      state: "Kies uit: \"Uitgevouwen\" - het paneel wordt volledig weergegeven en kan worden ingeklapt; \"Samengevouwen\" - het paneel toont alleen de titel en beschrijving en kan worden uitgevouwen; \"Vergrendeld\" - het paneel wordt volledig weergegeven en kan niet worden ingeklapt.",
      // "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)."
      width: "Hiermee stelt u de breedte van het paneel in verhouding tot andere enquête-elementen in dezelfde lijn. Accepteert CSS-waarden (px, %, in, pt, enz.).",
      // "Type in a template for entry titles. Use {panelIndex} for the entry's general position and {visiblePanelIndex} for its order among visible entries. Insert these placeholders into the pattern to add automatic numbering."
      templateTitle: "Typ een sjabloon voor dynamische paneeltitels. Gebruik {panelIndex} voor de algemene positie van het paneel en {visiblePanelIndex} voor de volgorde tussen de zichtbare panelen. Voeg deze tijdelijke aanduidingen toe aan het patroon om automatische nummering toe te voegen.",
      // "Type in a template for tab titles. Use {panelIndex} for an entry's general position and {visiblePanelIndex} for its order among visible entries. Insert these placeholders into the pattern to add automatic numbering."
      templateTabTitle: "Typ een sjabloon voor tabbladtitels. Gebruik {panelIndex} voor de algemene positie van een paneel en {visiblePanelIndex} voor de volgorde tussen zichtbare panelen. Voeg deze tijdelijke aanduidingen toe aan het patroon om automatische nummering toe te voegen.",
      // "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value."
      tabTitlePlaceholder: "Een terugvaltekst voor tabbladtitels die van toepassing is wanneer het patroon van de tabbladtitel geen zinvolle waarde oplevert.",
      // "This setting allows you to control the visibility of individual entries within the dynamic panel. Use the `{panel}` placeholder to reference the current entry in your expression."
      templateVisibleIf: "Met deze instelling kunt u de zichtbaarheid van afzonderlijke panelen binnen het dynamische paneel regelen. Gebruik de tijdelijke aanduiding '{panel}' om te verwijzen naar het huidige deelvenster in uw expressie.",
      // "This setting is automatically inherited by all questions within this dynamic panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default)."
      titleLocation: "Deze instelling wordt automatisch overgenomen door alle vragen in dit paneel. Als u deze instelling wilt overschrijven, definieert u regels voor titeluitlijning voor afzonderlijke vragen. De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau (\"Standaard bovenaan\") toe.",
      // "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default)."
      descriptionLocation: "De optie \"Overnemen\" past de instelling op paginaniveau (indien ingesteld) of enquêteniveau toe (\"Standaard onder de paneeltitel\").",
      // "Defines the position of a newly added entry. By default, new entries are added to the end. Select \"Next\" to insert a new entry after the current one."
      newPanelPosition: "Definieert de positie van een nieuw toegevoegd deelvenster. Standaard worden er nieuwe panelen aan het einde toegevoegd. Selecteer \"Volgende\" om een nieuw paneel in te voegen na het huidige.",
      // [Auto-translated] "Duplicates answers from the last entry and assigns them to the next added entry."
      copyDefaultValueFromLastEntry: "Dupliceert antwoorden van de laatste invoer en wijst ze toe aan de volgende toegevoegde invoer.",
      // "Reference a question name to require a user to provide a unique response for this question in each entry."
      keyName: "Verwijs naar een vraagnaam om te vereisen dat een gebruiker in elk deelvenster een uniek antwoord geeft op deze vraag.",
      // [Auto-translated] "Triggers a confirmation prompt before removing an entry."
      confirmDelete: "Activeert een bevestigingsprompt voordat een item wordt verwijderd.",
      // [Auto-translated] "Assigns numbers to questions nested within the dynamic panel."
      showQuestionNumbers: "Wijst nummers toe aan vragen die zijn genest in het dynamische paneel."
    },
    matrixdynamic: {
      // [Auto-translated] "Triggers a confirmation prompt before removing a row."
      confirmDelete: "Activeert een bevestigingsprompt voordat een rij wordt verwijderd.",
      // [Auto-translated] "Automatically expands the detail section when a new row is added to the matrix."
      detailPanelShowOnAdding: "Breidt de detailsectie automatisch uit wanneer een nieuwe rij aan de matrix wordt toegevoegd."
    },
    // "Duplicates answers from the last row and assigns them to the next added dynamic row."
    copyDefaultValueFromLastEntry: "Dupliceert antwoorden uit de laatste rij en wijst ze toe aan de volgende toegevoegde dynamische rij.",
    // [Auto-translated] "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input."
    defaultValueExpression: "Met deze instelling kunt u een standaardantwoordwaarde toewijzen op basis van een expressie. De expressie kan basisberekeningen bevatten - '{q1_id} + {q2_id}', Booleaanse expressies, zoals '{age} > 60', en functies: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', enz. De waarde die door deze expressie wordt bepaald, dient als de oorspronkelijke standaardwaarde die kan worden overschreven door de handmatige invoer van een respondent.",
    // "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set)."
    resetValueIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die bepaalt wanneer de invoer van een respondent wordt teruggezet naar de waarde op basis van de \"Standaardwaarde-expressie\" of \"Waarde-expressie instellen\" of naar de waarde \"Standaardantwoord\" (als een van beide is ingesteld).",
    // "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response."
    setValueIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die bepaalt wanneer de expressie 'Waarde instellen' moet worden uitgevoerd en wijs de resulterende waarde dynamisch toe als antwoord.",
    // "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input."
    setValueExpression: "Geef een expressie op die de waarde definieert die moet worden ingesteld wanneer aan de voorwaarden in de regel 'Waarde instellen als' wordt voldaan. De expressie kan basisberekeningen bevatten - '{q1_id} + {q2_id}', Booleaanse expressies, zoals '{age} > 60', en functies: 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', enz. De waarde die door deze expressie wordt bepaald, kan worden overschreven door de handmatige invoer van een respondent.",
    // "Survey Creator allows you to manually adjust the inline widths of form elements to control the layout. If this doesn't produce the desired outcome, you can enable the grid layout, which structures form elements using a column-based system. To configure layout columns, select a page or panel and use the \"Question Settings\" → \"Grid columns\" table. To adjust how many columns a question spans, select it and set the desired value in the \"Layout\" → \"Column span\" field."
    gridLayoutEnabled: "Met Survey Creator kunt u de inlinebreedtes van formulierelementen handmatig aanpassen om de lay-out te beheren. Als dit niet het gewenste resultaat oplevert, kunt u de rasterlay-out inschakelen, waarvan de structuren elementen vormen met behulp van een op kolommen gebaseerd systeem. Om lay-outkolommen te configureren, selecteer je een pagina of paneel en gebruik je de tabel \"Vraaginstellingen\" → \"Rasterkolommen\". Om aan te passen hoeveel kolommen een vraag beslaat, selecteer je deze en stel je de gewenste waarde in in het veld \"Lay-out\" → \"Kolomspanwijdte\".",
    question: {
      // "A question ID that is not visible to respondents."
      name: "Een vraag-ID die niet zichtbaar is voor respondenten.",
      // "Type a question subtitle."
      description: "Typ de ondertitel van een vraag.",
      // "Use the magic wand icon to set a conditional rule that determines question visibility."
      visibleIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de zichtbaarheid van de vraag bepaalt.",
      // [Auto-translated] "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question."
      enableIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de alleen-lezen modus voor de vraag uitschakelt.",
      // "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer."
      requiredIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die voorkomt dat de enquête wordt voortgezet of verzonden, tenzij de vraag een antwoord heeft gekregen.",
      // [Auto-translated] "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form."
      startWithNewLine: "Schakel de optie uit om de vraag op één regel weer te geven met de vorige vraag of het vorige deelvenster. De instelling is niet van toepassing als de vraag het eerste element in uw formulier is.",
      // "Repositions the question to the end of a selected page."
      page: "Hiermee verplaatst u de vraag naar het einde van een geselecteerde pagina.",
      // "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed."
      state: "Kies uit: \"Uitgevouwen\" - het vraagvak wordt volledig weergegeven en kan worden ingeklapt; \"Samengevouwen\" - het vraagvak toont alleen de titel en beschrijving en kan worden uitgevouwen; \"Vergrendeld\" - het vraagvak wordt volledig weergegeven en kan niet worden ingeklapt.",
      // "Overrides title alignment rules defined on a panel, page, or survey level. When set to \"Hidden\", it also hides question descriptions. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default)."
      titleLocation: "Hiermee worden regels voor titeluitlijning overschreven die zijn gedefinieerd op paneel-, pagina- of enquêteniveau. De optie \"Overnemen\" past alle instellingen op een hoger niveau (indien ingesteld) of instellingen op enquêteniveau (\"Top\" standaard) toe.",
      // "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default)."
      descriptionLocation: "De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Standaard onder de vraagtitel\").",
      // "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)."
      errorLocation: "Hiermee stelt u de locatie van een foutmelding in ten opzichte van de vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst. De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Top\" standaard).",
      // "Adds space or margin between the question content and the left border of the question box."
      indent: "Hiermee voegt u ruimte of marge toe tussen de inhoud van de vraag en de linkerrand van het vraagvak.",
      // "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.)."
      width: "Hiermee stelt u de breedte van de vraag in verhouding tot andere enquête-elementen in dezelfde regel. Accepteert CSS-waarden (px, %, in, pt, enz.).",
      // "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default)."
      textUpdateMode: "Kies uit: \"Bij verloren focus\" - de waarde wordt bijgewerkt wanneer het invoerveld de focus verliest; \"Tijdens het typen\" - de waarde wordt in realtime bijgewerkt, terwijl gebruikers typen. Met de optie \"Overerven\" wordt de instelling op enquêteniveau toegepast (\"Standaard bij verloren focus\").",
      // [Auto-translated] "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data."
      url: "U kunt elke webservice gebruiken als gegevensbron voor meerkeuzevragen. Als u keuzewaarden wilt invullen, voert u de URL in van de service die de gegevens levert.",
      // [Auto-translated] "A comparison operation used to filter the drop-down list."
      searchMode: "Een vergelijkingsbewerking die wordt gebruikt om de vervolgkeuzelijst te filteren.",
      // [Auto-translated] "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip."
      textWrapEnabled: "Lange teksten in keuze-opties genereren automatisch regeleinden die in het vervolgkeuzemenu passen. Schakel de selectie uit als u wilt dat de teksten worden afgekapt.",
      // [Auto-translated] "Specifies how many columns this question spans within the grid layout."
      effectiveColSpan: "Hiermee geeft u aan hoeveel kolommen deze vraag beslaat binnen de rasterlay-out."
    },
    surveyvalidator: {
      // "Use the magic wand icon to define when the question's value is considered valid."
      expression: "Gebruik het toverstokpictogram om te definiëren wanneer de waarde van de vraag als geldig wordt beschouwd.",
      // [Auto-translated] "Errors block progress until resolved. Warnings highlight issues but allow to continue. Informational notes offer additional context or neutral guidance. When using warnings or informational notes, we recommend enabling immediate validation: \"Survey\" → \"Validation\" → \"Run validation\" → \"After an answer has changed\"."
      notificationType: "Fouten blokkeren de voortgang totdat ze zijn opgelost. Waarschuwingen markeren problemen, maar laten doorgaan toe. Informatieve notities bieden extra context of neutrale begeleiding. Wanneer u waarschuwingen of informatieve notities gebruikt, raden we aan om onmiddellijke validatie in te schakelen: 'Enquête' → 'Validatie' → 'Validatie uitvoeren' → 'Nadat een antwoord is gewijzigd'."
    },
    signaturepad: {
      // "Sets the width of the displayed signature area and the resulting image."
      signatureWidth: "Hiermee stelt u de breedte van het weergegeven handtekeninggebied en de resulterende afbeelding in.",
      // "Sets the height of the displayed signature area and the resulting image."
      signatureHeight: "Hiermee stelt u de hoogte in van het weergegeven handtekeninggebied en de resulterende afbeelding.",
      // "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions."
      signatureAutoScaleEnabled: "Selecteer of u wilt dat het handtekeninggebied alle beschikbare ruimte in het vraagvak vult met behoud van de standaardverhouding van 3:2. Wanneer aangepaste breedte- en hoogtewaarden zijn ingesteld, blijft de hoogte-breedteverhouding van deze afmetingen behouden."
    },
    file: {
      // "Specifies the display height of uploaded images in the preview and the actual height of images taken with the camera. In single file upload mode, the display height is limited by the preview area; in multiple file upload mode, it is limited by the thumbnail area."
      imageHeight: "Hiermee geeft u de weergavehoogte op van geüploade afbeeldingen in het voorbeeld en de werkelijke hoogte van de foto's die met de camera zijn gemaakt. In de uploadmodus voor één bestand wordt de weergavehoogte beperkt door het voorbeeldgebied; In de modus voor het uploaden van meerdere bestanden wordt dit beperkt door het miniatuurgebied.",
      // "Specifies the display width of uploaded images in the preview and the actual width of images taken with the camera. In single file upload mode, the display width is limited by the preview area; in multiple file upload mode, it is limited by the thumbnail area."
      imageWidth: "Hiermee geeft u de weergavebreedte op van geüploade afbeeldingen in het voorbeeld en de werkelijke breedte van de foto's die met de camera zijn gemaakt. In de uploadmodus voor één bestand wordt de weergavebreedte beperkt door het voorbeeldgebied; In de modus voor het uploaden van meerdere bestanden wordt dit beperkt door het miniatuurgebied.",
      // [Auto-translated] "Displays thumbnail previews for uploaded files when possible. Unselect if you want to show file icons instead."
      allowImagesPreview: "Geeft indien mogelijk miniatuurvoorbeelden weer voor geüploade bestanden. Schakel de selectie uit als u in plaats daarvan bestandspictogrammen wilt weergeven."
    },
    image: {
      // "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided."
      contentMode: "De optie \"Auto\" bepaalt automatisch de geschikte modus voor weergave - Afbeelding, Video of YouTube - op basis van de opgegeven bron-URL."
    },
    imagepicker: {
      // [Auto-translated] "Overrides the minimum and maximum height values."
      imageHeight: "Hiermee worden de minimum- en maximumhoogtewaarden overschreven.",
      // [Auto-translated] "Overrides the minimum and maximum width values."
      imageWidth: "Hiermee worden de waarden voor de minimum- en maximumbreedte overschreven.",
      // [Auto-translated] "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents."
      choices: "\"Waarde\" dient als een item-ID die wordt gebruikt in voorwaardelijke regels; \"Tekst\" wordt weergegeven aan respondenten.",
      // "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options."
      contentMode: "Kies tussen \"Afbeelding\" en \"Video\" om de inhoudsmodus van de mediakiezer in te stellen. Als \"Afbeelding\" is geselecteerd, zorg er dan voor dat alle beschikbare opties afbeeldingsbestanden zijn in de volgende formaten: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Evenzo, als \"Video\" is geselecteerd, zorg er dan voor dat alle opties directe links zijn naar videobestanden in de volgende formaten: MP4, MOV, WMV, FLV, AVI, MKV. Houd er rekening mee dat YouTube-links niet worden ondersteund voor video-opties."
    },
    text: {
      // [Auto-translated] "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to \"Validation\" → \"Maximum character limit\"."
      size: "Met deze instelling wordt alleen het formaat van het invoerveld gewijzigd en wordt de breedte van het vraagvak niet beïnvloed. Om de geaccepteerde invoerlengte te beperken, gaat u naar \"Validatie\" → \"Maximale tekenlimiet\"."
    },
    comment: {
      // [Auto-translated] "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear."
      rows: "Hiermee stelt u het aantal weergegeven regels in het invoerveld in. Als de invoer meer regels in beslag neemt, verschijnt de schuifbalk."
    },
    // survey templates
    survey: {
      // "Select if you want to prevent respondents from filling out your survey."
      readOnly: "Selecteer deze optie als u wilt voorkomen dat respondenten uw enquête invullen.",
      // "Sets the location of the progress bar. The \"Auto\" value displays the progress bar above or below the survey header."
      progressBarLocation: "Hiermee stelt u de locatie van de voortgangsbalk in. De waarde \"Auto\" geeft de voortgangsbalk boven of onder de kop van de enquête weer."
    },
    matrixdropdowncolumn: {
      // "A column ID that is not visible to respondents."
      name: "Een kolom-id die niet zichtbaar is voor respondenten.",
      // "When enabled for a column, a respondent is required to provide a unique response for each question within this column."
      isUnique: "Als deze optie is ingeschakeld voor een kolom, moet een respondent een uniek antwoord geven voor elke vraag in deze kolom.",
      // "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear."
      rows: "Hiermee stelt u het aantal weergegeven regels in het invoerveld in. Als de invoer meer regels in beslag neemt, verschijnt de schuifbalk.",
      // "Use the magic wand icon to set a conditional rule that determines column visibility."
      visibleIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen die de zichtbaarheid van de kolom bepaalt.",
      // [Auto-translated] "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column."
      enableIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen waarmee de alleen-lezen modus voor de kolom wordt uitgeschakeld.",
      // "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer."
      requiredIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft.",
      // "When selected, creates an individual column for each choice option."
      showInMultipleColumns: "Als deze optie is geselecteerd, wordt er een afzonderlijke kolom gemaakt voor elke keuzeoptie.",
      // [Auto-translated] "Arranges choice options in a multi-column layout. When set to 0, the options are displayed in a single line. When set to -1, the actual value is inherited from the \"Nested column count\" property of the parent matrix."
      colCount: "Rangschikt keuzeopties in een lay-out met meerdere kolommen. Wanneer deze is ingesteld op 0, worden de opties op één regel weergegeven. Wanneer deze instelling is ingesteld op -1, wordt de werkelijke waarde overgenomen van de eigenschap 'Aantal geneste kolommen' van de bovenliggende matrix."
    },
    slider: {
      // "The lowest number that users can select."
      min: "Het laagste getal dat gebruikers kunnen selecteren.",
      // "The highest number that users can select."
      max: "Het hoogste aantal dat gebruikers kunnen selecteren.",
      // "The interval between selectable scale values. For example, a step of 5 will allow users to select 0, 5, 10, etc."
      step: "Het interval tussen selecteerbare schaalwaarden. Met een stap van 5 kunnen gebruikers bijvoorbeeld 0, 5, 10, enz. selecteren.",
      // "The minimum distance between the slider thumbs a user can set."
      minRangeLength: "De minimale afstand tussen de schuifknoppen die een gebruiker kan instellen.",
      // "The maximum distance between the slider thumbs a user can set."
      maxRangeLength: "De maximale afstand tussen de schuifknoppen die een gebruiker kan instellen.",
      // "Specifies how many scale labels to generate. A value of -1 means the number is calculated automatically based on the Min value and Max value."
      labelCount: "Geeft aan hoeveel schaallabels moeten worden gegenereerd. Een waarde van -1 betekent dat het getal automatisch wordt berekend op basis van de Min-waarde en de Max-waarde.",
      // "Use `{0}` as a placeholder for the actual value."
      labelFormat: "Gebruik '{0}' als tijdelijke aanduiding voor de werkelijke waarde.",
      // "Allows you to define custom labels at specific values and optionally assign corresponding text to them (e.g., 0 = \"Poor\", 100 = \"Excellent\")."
      customLabels: "Hiermee kunt u aangepaste labels met specifieke waarden definiëren en er optioneel overeenkomstige tekst aan toewijzen (bijv. 0 = \"Slecht\", 100 = \"Uitstekend\").",
      // "Use `{0}` as a placeholder for the actual value."
      tooltipFormat: "Gebruik '{0}' als tijdelijke aanduiding voor de werkelijke waarde.",
      // "Allows users to move one thumb past the other."
      allowSwap: "Hiermee kunnen gebruikers de ene duim langs de andere bewegen.",
      // [Auto-translated] "Displays a button that clears the selected slider value and sets it to undefined."
      allowClear: "Geeft een knop weer waarmee de geselecteerde schuifregelaarwaarde wordt gewist en op niet-gedefinieerd wordt gezet.",
      // "Defines the slider's minimum value dynamically using an expression. Supports basic calculations (e.g, `{q1_id} + {q2_id}`), Boolean logic (e.g., `{age} > 60`), and functions like `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, and more."
      minValueExpression: "Definieert de minimumwaarde van de schuifregelaar dynamisch met behulp van een expressie. Ondersteunt basisberekeningen (bijv. '{q1_id} + {q2_id}'), Booleaanse logica (bijv. '{age} > 60') en functies zoals 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' en meer.",
      // "Defines the slider's maximum value dynamically using an expression. Supports basic calculations (e.g, `{q1_id} + {q2_id}`), Boolean logic (e.g., `{age} > 60`), and functions like `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, and more."
      maxValueExpression: "Definieert de maximale waarde van de schuifregelaar dynamisch met behulp van een expressie. Ondersteunt basisberekeningen (bijv. '{q1_id} + {q2_id}'), Booleaanse logica (bijv. '{age} > 60') en functies zoals 'iif()', 'today()', 'age()', 'min()', 'max()', 'avg()' en meer."
    },
    // [Auto-translated] "Makes this choice exclusive. When selected by a user, it will automatically deselect all other options in the question."
    isExclusive: "Maakt deze keuze exclusief. Wanneer een gebruiker deze selecteert, worden automatisch alle andere opties in de vraag gedeselecteerd.",
    matrixcolumn: {
      // [Auto-translated] "Makes checkboxes in this column exclusive. When selected by a user, they will automatically deselect all other checkboxes in the same row."
      isExclusive: "Maakt selectievakjes in deze kolom exclusief. Wanneer een gebruiker deze selecteert, worden alle andere selectievakjes in dezelfde rij automatisch uitgeschakeld."
    },
    // [Auto-translated] "Select if uppercase and lowercase letters in the regular expression must be treated as equivalent."
    caseInsensitive: "Selecteer of hoofdletters en kleine letters in de reguliere expressie als gelijkwaardig moeten worden behandeld.",
    // "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used."
    widthMode: "Kies uit: \"Statisch\" - stelt een vaste breedte in; \"Responsief\" - zorgt ervoor dat de enquête de volledige breedte van het scherm in beslag neemt; \"Auto\" - past een van de twee toe, afhankelijk van de gebruikte vraagtypen.",
    // [Auto-translated] "Assign a unique cookie value for your survey. The cookie will be set in a respondent's browser upon survey completion to prevent repetitive survey submissions."
    cookieName: "Wijs een unieke cookiewaarde toe aan uw enquête. De cookie wordt na voltooiing van de enquête in de browser van een respondent geplaatst om herhaling van de enquête te voorkomen.",
    // [Auto-translated] "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB)."
    logo: "Plak een afbeeldingslink (geen maximale grootte) of klik op het mappictogram om door een bestand vanaf uw computer te bladeren (maximaal 64 KB).",
    // [Auto-translated] "Sets a logo width in CSS units (px, %, in, pt, etc.)."
    logoWidth: "Hiermee stelt u de breedte van het logo in CSS-eenheden in (px, %, in, pt, enz.).",
    // [Auto-translated] "Sets a logo height in CSS units (px, %, in, pt, etc.)."
    logoHeight: "Hiermee stelt u de hoogte van een logo in CSS-eenheden in (px, %, in, pt, enz.).",
    // "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio."
    logoFit: "Kies uit: \"Geen\" - afbeelding behoudt zijn oorspronkelijke grootte; \"Bevatten\" - het formaat van de afbeelding wordt aangepast aan de beeldverhouding met behoud van de beeldverhouding; \"Omslag\" - afbeelding vult het hele vak met behoud van de beeldverhouding; \"Vullen\" - de afbeelding wordt uitgerekt om het vak te vullen zonder de beeldverhouding te behouden.",
    // [Auto-translated] "Select if you want the survey to auto-advance to the next page once a respondent has answered all questions on the current page. This feature won't apply if the last question on the page is open-ended or allows multiple answers."
    autoAdvanceEnabled: "Selecteer of u wilt dat de enquête automatisch naar de volgende pagina gaat zodra een respondent alle vragen op de huidige pagina heeft beantwoord. Deze functie is niet van toepassing als de laatste vraag op de pagina een open einde heeft of meerdere antwoorden toestaat.",
    // [Auto-translated] "Select if you want the survey to complete automatically after a respondent answers all questions."
    autoAdvanceAllowComplete: "Selecteer of u wilt dat de enquête automatisch wordt ingevuld nadat een respondent alle vragen heeft beantwoord.",
    // [Auto-translated] "Sets the visibility of navigation buttons on a page."
    showNavigationButtons: "Hiermee stelt u de zichtbaarheid van navigatieknoppen op een pagina in.",
    // [Auto-translated] "Sets the location of navigation buttons on a page."
    navigationButtonsLocation: "Hiermee stelt u de locatie van navigatieknoppen op een pagina in.",
    // [Auto-translated] "Enable the preview page with all or answered questions only."
    showPreviewBeforeComplete: "Schakel de voorbeeldpagina in met alleen alle of beantwoorde vragen.",
    // "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level."
    questionTitleLocation: "Geldt voor alle vragen in de enquête. Deze instelling kan worden overschreven door regels voor titeluitlijning op lagere niveaus: deelvenster, pagina of vraag. Een instelling op een lager niveau heeft voorrang op die op een hoger niveau.",
    // [Auto-translated] "A symbol or a sequence of symbols indicating that an answer is required."
    requiredMark: "Een symbool of een reeks symbolen die aangeven dat een antwoord vereist is.",
    // [Auto-translated] "Enter a number or letter with which you want to start numbering."
    questionStartIndex: "Voer een cijfer of letter in waarmee u wilt beginnen met nummeren.",
    // "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box."
    questionErrorLocation: "Hiermee stelt u de locatie van een foutmelding in ten opzichte van de vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst.",
    // [Auto-translated] "Select if you want the first input field on each page ready for text entry."
    autoFocusFirstQuestion: "Selecteer of u het eerste invoerveld op elke pagina klaar wilt maken voor tekstinvoer.",
    // "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab."
    questionOrder: "Behoudt de oorspronkelijke volgorde van vragen of maakt ze willekeurig. Het effect van deze instelling is alleen zichtbaar op het tabblad Voorbeeld.",
    // [Auto-translated] "For text entry questions only."
    maxTextLength: "Alleen voor vragen over tekstinvoer.",
    // [Auto-translated] "For question comments only."
    maxCommentLength: "Alleen voor opmerkingen over vragen.",
    // [Auto-translated] "Sets the number of displayed lines in text areas for question comments. If the input takes up more lines, the scroll bar appears."
    commentAreaRows: "Hiermee stelt u het aantal weergegeven regels in tekstgebieden in voor opmerkingen bij vragen. Als de invoer meer regels in beslag neemt, wordt de schuifbalk weergegeven.",
    // [Auto-translated] "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length."
    autoGrowComment: "Selecteer of u wilt dat vraagopmerkingen en lange tekstvragen automatisch in hoogte groeien op basis van de ingevoerde tekstlengte.",
    // [Auto-translated] "For question comments and Long Text questions only."
    allowResizeComment: "Alleen voor vraagopmerkingen en lange tekstvragen.",
    // [Auto-translated] "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on."
    calculatedValues: "Aangepaste variabelen dienen als tussenliggende of hulpvariabelen die worden gebruikt in formulierberekeningen. Ze nemen de input van respondenten als bronwaarden. Elke aangepaste variabele heeft een unieke naam en een expressie waarop deze is gebaseerd.",
    // [Auto-translated] "Select if you wish the calculated value of the expression to be saved along with survey results."
    includeIntoResult: "Selecteer of u wilt dat de berekende waarde van de expressie samen met de enquêteresultaten wordt opgeslagen.",
    // "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects."
    triggers: "Een trigger is een gebeurtenis of voorwaarde die is gebaseerd op een expressie. Zodra de expressie is geëvalueerd naar 'waar', wordt een actie geactiveerd door een trigger. Zo'n actie kan optioneel een doelvraag hebben die het beïnvloedt.",
    // [Auto-translated] "Choose whether or not to clear values for questions hidden by conditional logic and when to do it."
    clearInvisibleValues: "Kies of u de waarden wilt wissen voor vragen die verborgen zijn door voorwaardelijke logica en wanneer u dit wilt doen.",
    // "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing."
    textUpdateMode: "Kies uit: \"Bij verloren focus\" - de waarde wordt bijgewerkt wanneer het invoerveld de focus verliest; \"Tijdens het typen\" - de waarde wordt in realtime bijgewerkt, terwijl gebruikers typen.",
    // [Auto-translated] "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents."
    columns: "De linkerwaarde dient als een kolom-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten.",
    // "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents."
    rows: "De linkerwaarde dient als een rij-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten.",
    // [Auto-translated] "Accepts CSS values (px, %, in, pt, etc.)."
    columnMinWidth: "Accepteert CSS-waarden (px, %, in, pt, enz.).",
    // [Auto-translated] "Accepts CSS values (px, %, in, pt, etc.)."
    rowTitleWidth: "Accepteert CSS-waarden (px, %, in, pt, enz.).",
    // [Auto-translated] "Visible only if at least one column displays total values set with \"Aggregation method\" or \"Total value expression\"."
    totalText: "Alleen zichtbaar als ten minste één kolom de totale waarden weergeeft die zijn ingesteld met \"Aggregatiemethode\" of \"Totale waarde-expressie\".",
    // "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property."
    cellErrorLocation: "Hiermee stelt u de locatie van een foutbericht in ten opzichte van een cel met ongeldige invoer. Met de optie 'Overerven' wordt de instelling van de eigenschap 'Uitlijning van foutberichten' toegepast.",
    // "Sets the location of error messages for questions nested in detail sections. The \"Inherit\" option applies the setting from the \"Error message alignment\" property."
    detailErrorLocation: "Hiermee stelt u de locatie in van foutmeldingen voor vragen die zijn genest in detailsecties. De optie \"Overerven\" past de instelling van de eigenschap \"Uitlijning van foutmeldingen\" toe.",
    // "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message."
    keyDuplicationError: "Wanneer de eigenschap 'Dubbele antwoorden voorkomen' is ingeschakeld, ontvangt een respondent die een dubbele vermelding probeert in te dienen, het volgende foutbericht.",
    matrixdropdown: {
      // [Auto-translated] "When the \"Prevent duplicate responses\" property is enabled for a matrix column, a respondent attempting to submit a duplicate entry will receive the following error message."
      keyDuplicationError: "Wanneer de eigenschap 'Dubbele reacties voorkomen' is ingeschakeld voor een matrixkolom, ontvangt een respondent die een dubbele invoer probeert in te dienen, het volgende foutbericht."
    },
    // [Auto-translated] "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)."
    totalExpression: "Hiermee kunt u totale waarden berekenen op basis van een expressie. De expressie kan basisberekeningen ('{q1_id} + {q2_id}'), Booleaanse expressies ('{age} > 60') en functies ('iif()', 'today()', 'age()', 'min()', 'max()', 'avg()', etc.) bevatten.",
    // "Reference a column ID to require a user to provide a unique response for each question within the specified column."
    keyName: "Als de opgegeven kolom identieke waarden bevat, genereert de enquête de fout 'Niet-unieke sleutelwaarde'.",
    // "Type a subtitle."
    description: "Typ een ondertitel.",
    // [Auto-translated] "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab."
    locale: "Kies een taal om te beginnen met het maken van uw enquête. Als u een vertaling wilt toevoegen, schakelt u over naar een nieuwe taal en vertaalt u de originele tekst hier of op het tabblad Vertalingen.",
    // "Sets the location of a detail section in relation to a row. Choose from: \"None\" - no detail section is added; \"Under the row\" - a detail section is placed under each row of the matrix; \"Under the row, display one detail section only\" - a detail section is displayed under a single row only, the remaining sections are collapsed."
    detailPanelMode: "Hiermee stelt u de locatie van een detailsectie ten opzichte van een rij in. Kies uit: \"Geen\" - er wordt geen uitbreiding toegevoegd; \"Onder de rij\" - onder elke rij van de matrix wordt een rij-uitbreiding geplaatst; \"Onder de rij, slechts één rij-uitbreiding weergeven\" - een uitbreiding wordt alleen onder een enkele rij weergegeven, de resterende rij-uitbreidingen zijn samengevouwen.",
    // "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio."
    imageFit: "Kies uit: \"Geen\" - afbeelding behoudt zijn oorspronkelijke grootte; \"Bevatten\" - het formaat van de afbeelding wordt aangepast aan de beeldverhouding met behoud van de beeldverhouding; \"Omslag\" - afbeelding vult het hele vak met behoud van de beeldverhouding; \"Vullen\" - de afbeelding wordt uitgerekt om het vak te vullen zonder de beeldverhouding te behouden.",
    // "The \"Inherit\" option applies a survey-level setting (\"Disabled\" by default)."
    autoGrow: "Verhoogt geleidelijk de hoogte van het invoerveld terwijl gegevens worden ingevoerd. Hiermee wordt de instelling \"Invoerveldhoogte (in lijnen)\" overschreven.",
    // [Auto-translated] "The \"Inherit\" option applies a survey-level setting (\"Enabled\" by default)."
    allowResize: "De optie \"Overnemen\" past een instelling op enquêteniveau toe (\"Standaard ingeschakeld\").",
    // [Auto-translated] "A time interval in seconds after which the survey auto-advances to the \"Thank You\" page. When set to 0, counts the time spent on the survey."
    timeLimit: "Een tijdsinterval in seconden, waarna de enquête automatisch naar de pagina 'Bedankt' gaat. Als deze instelling is ingesteld op 0, wordt de tijd geteld die aan de enquête is besteed.",
    // [Auto-translated] "A time interval in seconds after which the survey auto-advances to the next page. Hides the \"Previous\" navigation button. When set to 0, counts the time spent on the current page."
    timeLimitPerPage: "Een tijdsinterval in seconden waarna de enquête automatisch naar de volgende pagina gaat. Verbergt de navigatieknop \"Vorige\". Indien ingesteld op 0, telt de tijd die op de huidige pagina is doorgebracht.",
    // [Auto-translated] "Enable this option to trigger validation when a user focuses on an empty input field and then leaves it without making any changes."
    validateVisitedEmptyFields: "Schakel deze optie in om validatie te activeren wanneer een gebruiker zich richt op een leeg invoerveld en dit vervolgens verlaat zonder wijzigingen aan te brengen.",
    page: {
      // "A page ID that is not visible to respondents."
      name: "Een pagina-ID die niet zichtbaar is voor respondenten.",
      // "Type a page subtitle."
      description: "Typ een pagina-ondertitel.",
      // "A caption displayed on a navigation button in the progress bar or table of contents (TOC). If you leave this field empty, the navigation button will use the page title or page name. To enable the progress bar or TOC, go to \"Survey\" → \"Navigation\"."
      navigationTitle: "Een bijschrift dat wordt weergegeven op een navigatieknop in de voortgangsbalk of inhoudsopgave (TOC). Als u dit veld leeg laat, gebruikt de navigatieknop de paginatitel of paginanaam. Om de voortgangsbalk of inhoudsopgave in te schakelen, ga je naar \"Enquête\" → \"Navigatie\".",
      // "A time interval in seconds after which the survey auto-advances to the next page. Hides the \"Previous\" navigation button. When set to 0, counts the time spent on the current page."
      timeLimit: "Een tijdsinterval in seconden, waarna de enquête automatisch doorgaat naar de volgende pagina.",
      // "Use the magic wand icon to set a conditional rule that determines page visibility."
      visibleIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de zichtbaarheid van de pagina bepaalt.",
      // [Auto-translated] "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page."
      enableIf: "Gebruik het pictogram van de toverstaf om een voorwaardelijke regel in te stellen waarmee de alleen-lezen modus voor de pagina wordt uitgeschakeld.",
      // "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer."
      requiredIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die het verzenden van enquêtes verhindert, tenzij ten minste één geneste vraag een antwoord heeft.",
      // "Applies to all questions within this page. When set to \"Hidden\", it also hides question descriptions. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)."
      questionTitleLocation: "Geldt voor alle vragen op deze pagina. Als je deze instelling wilt overschrijven, definieer je regels voor titeluitlijning voor afzonderlijke vragen of panelen. De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Top\" standaard).",
      // [Auto-translated] "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.)."
      questionTitleWidth: "Hiermee stelt u een consistente breedte in voor vraagtitels wanneer deze links van de vraagvakken zijn uitgelijnd. Accepteert CSS-waarden (px, %, in, pt, enz.).",
      // "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default)."
      questionErrorLocation: "Hiermee stelt u de locatie van een foutmelding in ten opzichte van de vraag met ongeldige invoer. Kies tussen: \"Top\" - er wordt een fouttekst bovenaan het vraagvak geplaatst; \"Onderaan\" - er wordt een fouttekst onderaan het vraagvak geplaatst. De optie \"Overnemen\" past de instelling op enquêteniveau toe (\"Top\" standaard).",
      // "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab."
      questionOrder: "Behoudt de oorspronkelijke volgorde van vragen of maakt ze willekeurig. De optie \"Overerven\" past de instelling op enquêteniveau toe (\"Standaard Origineel\"). Het effect van deze instelling is alleen zichtbaar op het tabblad Voorbeeld.",
      // "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"."
      showNavigationButtons: "Hiermee stelt u de zichtbaarheid van navigatieknoppen op de pagina in. De optie \"Overerven\" past de instelling op enquêteniveau toe, die standaard op \"Zichtbaar\" staat.",
      // [Auto-translated] "This table lets you configure each grid column on the page. It automatically sets the width percentage for each column based on the maximum number of elements in a row. To customize the grid layout, manually adjust these values and define the title width for all questions in each column."
      gridLayoutColumns: "Met deze tabel kunt u elke rasterkolom op de pagina configureren. Het stelt automatisch het breedtepercentage voor elke kolom in op basis van het maximale aantal elementen in een rij. Als u de rasterlay-out wilt aanpassen, past u deze waarden handmatig aan en definieert u de titelbreedte voor alle vragen in elke kolom."
    },
    // [Auto-translated] "Sets the location of a timer on a page."
    timerLocation: "Hiermee stelt u de locatie van een timer op een pagina in.",
    // "Choose from: \"Locked\" - users cannot expand or collapse entries; \"Collapse all\" - all entries start in a collapsed state; \"Expand all\" - all entries start in an expanded state; \"First expanded\" - only the first entry is initially expanded. Applies if \"Entry display mode\" is set to \"List\" and the \"Entry title pattern\" property is specified."
    panelsState: "Kies uit: \"Vergrendeld\" - gebruikers kunnen panelen niet uitvouwen of samenvouwen; \"Alles samenvouwen\" - alle deelvensters beginnen in een samengevouwen toestand; \"Alles uitvouwen\" - alle deelvensters beginnen in een uitgevouwen staat; \"Eerst uitgevouwen\" - alleen het eerste paneel wordt in eerste instantie uitgevouwen.",
    // [Auto-translated] "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list."
    imageLinkName: "Voer de naam van een gedeelde eigenschap in binnen de matrix met objecten die de URL's van afbeeldings- of videobestanden bevat die u in de keuzelijst wilt weergeven.",
    // "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents."
    choices: "De linkerwaarde dient als een item-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten.",
    // [Auto-translated] "Type a user-friendly title to display."
    title: "Typ een gebruiksvriendelijke titel om weer te geven.",
    // [Auto-translated] "Ensures that users won't complete the survey until files are uploaded."
    waitForUpload: "Zorgt ervoor dat gebruikers de enquête pas invullen als de bestanden zijn geüpload.",
    // [Auto-translated] "Accepts CSS values (px, %, in, pt, etc.)."
    minWidth: "Accepteert CSS-waarden (px, %, in, pt, enz.).",
    // [Auto-translated] "Accepts CSS values (px, %, in, pt, etc.)."
    maxWidth: "Accepteert CSS-waarden (px, %, in, pt, enz.).",
    // "Accepts CSS values (px, %, in, pt, etc.)."
    width: "Accepteert CSS-waarden (px, %, in, pt, enz.).",
    // [Auto-translated] "A join identifier is a custom key that you can assign to several questions to link them together and sync their values. These values will be merged into a single array or object and stored in survey results using the key as the property name."
    valueName: "Een join-ID is een aangepaste sleutel die u aan verschillende vragen kunt toewijzen om ze aan elkaar te koppelen en hun waarden te synchroniseren. Deze waarden worden samengevoegd tot één matrix of object en opgeslagen in enquêteresultaten met de sleutel als eigenschapsnaam.",
    // [Auto-translated] "A value displayed in HTML questions and in the dynamic titles and descriptions of survey elements when the question value is empty."
    defaultDisplayValue: "Een waarde die wordt weergegeven in HTML-vragen en in de dynamische titels en beschrijvingen van enquête-elementen wanneer de vraagwaarde leeg is.",
    // [Auto-translated] "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements."
    useDisplayValuesInDynamicTexts: "In vraagtypen met enkelvoudige en meervoudige selectie heeft elke keuzeoptie een ID en weergavewaarde. Als deze instelling is geselecteerd, wordt een weergavewaarde weergegeven in plaats van een ID-waarde in HTML-vragen en dynamische titels en beschrijvingen van enquête-elementen.",
    // "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default)."
    clearIfInvisible: "Kies of vraagwaarden die verborgen zijn door voorwaardelijke logica al dan niet moeten worden gewist en wanneer u dit wilt doen. Met de optie \"Overnemen\" wordt de instelling op enquêteniveau toegepast (\"Na voltooiing van de enquête\" standaard).",
    // "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question."
    choicesFromQuestionMode: "Kies uit: \"Alle\" - kopieert alle keuzemogelijkheden van de geselecteerde vraag; \"Geselecteerd\" - kopieert dynamisch alleen geselecteerde keuzeopties; \"Niet geselecteerd\" - kopieert dynamisch alleen niet-geselecteerde keuzeopties. De opties \"Geen\" en \"Overig\" worden standaard gekopieerd als deze zijn ingeschakeld in de bronvraag.",
    // [Auto-translated] "In single- and multiple-selection question types, each choice option has an ID and display value. This setting specifies which matrix column or panel question should provide the IDs."
    choiceValuesFromQuestion: "In vraagtypen met enkelvoudige en meervoudige selectie heeft elke keuzeoptie een ID en weergavewaarde. Deze instelling geeft aan welke matrixkolom of paneelvraag de ID's moeten bevatten.",
    // [Auto-translated] "In single- and multiple-selection question types, each choice option has an ID and display value. This setting specifies which matrix column or panel question should provide the display texts."
    choiceTextsFromQuestion: "In vraagtypen met enkelvoudige en meervoudige selectie heeft elke keuzeoptie een ID en weergavewaarde. Deze instelling geeft aan welke matrixkolom of paneelvraag de weergaveteksten moet opleveren.",
    // [Auto-translated] "Select to let respondents add their own choices if the desired option isn't available in the dropdown. Custom choices will only be stored temporarily for the duration of the current browser session."
    allowCustomChoices: "Selecteer deze optie om respondenten hun eigen keuzes te laten toevoegen als de gewenste optie niet beschikbaar is in de vervolgkeuzelijst. Aangepaste keuzes worden slechts tijdelijk opgeslagen voor de duur van de huidige browsersessie.",
    // [Auto-translated] "When selected, users can include additional input in a separate comment box."
    showOtherItem: "Als deze optie is geselecteerd, kunnen gebruikers extra invoer invullen in een apart invulveld.",
    // "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout."
    separateSpecialChoices: "Geeft elke speciale keuzeoptie ('Geen', 'Overig', 'Alles selecteren') weer op een nieuwe regel, zelfs bij gebruik van een lay-out met meerdere kolommen.",
    // [Auto-translated] "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array."
    path: "Geef de locatie binnen de servicegegevensset op waar de doelmatrix met objecten zich bevindt. Laat leeg als de URL al naar de array verwijst.",
    choicesbyurl: {
      // "Enter a uniform property name within the array of objects whose value will be stored as a response in survey results."
      valueName: " "
    },
    // [Auto-translated] "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list."
    titleName: "Voer een uniforme eigenschapsnaam in binnen de matrix met objecten die de waarden bevat die u in de keuzelijst wilt weergeven.",
    // [Auto-translated] "Select to allow the service to return an empty response or array."
    allowEmptyResponse: "Selecteer deze optie om toe te staan dat de service een leeg antwoord of een lege matrix retourneert.",
    // [Auto-translated] "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options."
    choicesVisibleIf: "Gebruik het toverstafpictogram om een voorwaardelijke regel in te stellen die de zichtbaarheid van alle keuzeopties bepaalt.",
    // [Auto-translated] "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents."
    rateValues: "De linkerwaarde dient als een item-ID die wordt gebruikt in voorwaardelijke regels, de rechterwaarde wordt weergegeven aan respondenten.",
    rating: {
      // "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown."
      displayMode: "\"Auto\" kiest tussen de modi \"Knoppen\" en \"Dropdown\" op basis van de beschikbare breedte. Wanneer de breedte onvoldoende is om knoppen weer te geven, wordt er een dropdown weergegeven in de vraag."
    },
    // [Auto-translated] "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values."
    valuePropertyName: "Hiermee kunt u vragen verbinden die resultaten opleveren in verschillende formaten. Wanneer dergelijke vragen aan elkaar zijn gekoppeld met behulp van een join-id, worden in deze gedeelde eigenschap geselecteerde vraagwaarden opgeslagen.",
    // [Auto-translated] "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field."
    searchEnabled: "Selecteer of u de inhoud van het vervolgkeuzemenu wilt bijwerken zodat deze overeenkomt met de zoekopdracht die een gebruiker in het invoerveld typt.",
    // [Auto-translated] "A value to save in survey results when respondents give a positive answer."
    valueTrue: "Een waarde die moet worden opgeslagen in enquêteresultaten wanneer respondenten een positief antwoord geven.",
    // [Auto-translated] "A value to save in survey results when respondents give a negative answer."
    valueFalse: "Een waarde die moet worden opgeslagen in enquêteresultaten wanneer respondenten een negatief antwoord geven.",
    // [Auto-translated] "It's not recommended that you disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded."
    showPreview: "Het wordt niet aanbevolen om deze optie uit te schakelen, omdat deze de voorbeeldafbeelding overschrijft en het voor een gebruiker moeilijk maakt om te begrijpen of de bestanden zijn geüpload.",
    // [Auto-translated] "Triggers a prompt asking to confirm the file deletion."
    needConfirmRemoveFile: "Hiermee wordt een prompt geactiveerd waarin wordt gevraagd om het verwijderen van het bestand te bevestigen.",
    // [Auto-translated] "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area."
    selectToRankEnabled: "Schakel in om alleen geselecteerde keuzes te rangschikken. Gebruikers slepen geselecteerde items uit de keuzelijst om ze binnen het rangschikkingsgebied te rangschikken.",
    // [Auto-translated] "Enter a list of choices that will be suggested to the respondent during input."
    dataList: "Voer een lijst met keuzes in die tijdens de invoer aan de respondent worden voorgesteld.",
    // [Auto-translated] "The setting only resizes the input fields and doesn't affect the width of the question box."
    inputSize: "De instelling wijzigt alleen de grootte van de invoervelden en heeft geen invloed op de breedte van het vraagvak.",
    // [Auto-translated] "Sets consistent width for all item labels. Accepts CSS values (px, %, in, pt, etc.)."
    itemTitleWidth: "Hiermee stelt u een consistente breedte in voor alle artikellabels. Accepteert CSS-waarden (px, %, %, in, pt, enz.).",
    // "Select how to align input value within the field. The default setting \"Auto\" aligns the input value to the right if currency or numeric masking is applied and to the left if not."
    inputTextAlignment: "Selecteer hoe u de invoerwaarde binnen het veld wilt uitlijnen. De standaardinstelling \"Auto\" lijnt de invoerwaarde uit aan de rechterkant als valuta- of numerieke maskering wordt toegepast en aan de linkerkant als dat niet het geval is.",
    // [Auto-translated] "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes."
    altText: "Dient als vervanging wanneer de afbeelding niet kan worden weergegeven op het apparaat van een gebruiker en voor toegankelijkheidsdoeleinden.",
    // "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale."
    rateColorMode: "Definieert de kleur van de geselecteerde emoji wanneer het type Beoordelingspictogram is ingesteld op \"Smileys\". Kies tussen: \"Standaard\" - de geselecteerde emoji verschijnt in de standaard enquêtekleur; \"Schaal\" - de geselecteerde emoji erft de kleur van de beoordelingsschaal.",
    expression: {
      // "An expression ID that is not visible to respondents."
      name: "Een expressie-ID die niet zichtbaar is voor respondenten.",
      // "Type an expression subtitle."
      description: "Typ de ondertitel van een expressie.",
      // "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)."
      expression: "Een expressie kan basisberekeningen ('{q1_id} + {q2_id}'), voorwaarden ('{leeftijd} > 60') en functies ('iif()', 'vandaag()', 'leeftijd()', 'min()', 'max()', 'gem()', enz.) bevatten."
    },
    // "Select to store the \"Other\" option value as a separate property in survey results."
    storeOthersAsComment: "Selecteer deze optie om de waarde van de optie 'Overig' op te slaan als een afzonderlijke eigenschap in enquêteresultaten.",
    // [Auto-translated] "Use {0} as a placeholder for the actual value."
    format: "Gebruik {0} als tijdelijke aanduiding voor de werkelijke waarde.",
    // [Auto-translated] "Select \"Custom\" to add your own file extensions on top of the predefined categories."
    acceptedCategories: "Selecteer \"Aangepast\" om je eigen bestandsextensies bovenop de vooraf gedefinieerde categorieën toe te voegen.",
    // [Auto-translated] "Enter file extensions separated by commas (e.g., .csv, .xml)."
    acceptedTypes: "Voer bestandsextensies in, gescheiden door komma's (bijvoorbeeld .csv, .xml).",
    // [Auto-translated] "Arranges choice options in a multi-column layout. When set to 0, the options are displayed in a single line. Applies only to columns with \"Cell input type\" set to Radio Button Group or Checkboxes."
    columnColCount: "Rangschikt keuzeopties in een lay-out met meerdere kolommen. Wanneer deze is ingesteld op 0, worden de opties op één regel weergegeven. Is alleen van toepassing op kolommen waarvoor \"Type celinvoer\" is ingesteld op Keuzerondje, Groep of selectievakjes.",
    // [Auto-translated] "Select the data type that the user's browser can retrieve. This data is sourced either from past values entered by the user or from pre-configured values if any have been saved by the user for autocompletion."
    autocomplete: "Selecteer het gegevenstype dat de browser van de gebruiker kan ophalen. Deze gegevens zijn afkomstig van waarden die in het verleden door de gebruiker zijn ingevoerd of van vooraf geconfigureerde waarden, indien van toepassing, die door de gebruiker zijn opgeslagen voor automatische aanvulling.",
    // "Applies when \"File source type\" is \"Local file\" or when camera is unavailable"
    filePlaceholder: "Van toepassing wanneer \"Brontype\" \"Lokale bestanden\" is of wanneer de camera niet beschikbaar is",
    // "Applies when \"File source type\" is \"Camera\"."
    photoPlaceholder: "Van toepassing wanneer \"Brontype\" \"Camera\" is.",
    // "Applies when \"File source type\" is \"Local file or camera\"."
    fileOrPhotoPlaceholder: "Van toepassing wanneer \"Brontype\" \"Lokale bestanden of camera\" is.",
    // "Arranges choice options in a multi-column layout. When set to 0, the options are displayed in a single line."
    colCount: "Rangschikt keuzeopties in een lay-out met meerdere kolommen. Als de optie op 0 staat, worden de opties op één regel weergegeven.",
    multipletext: {
      // [Auto-translated] "Arranges text boxes in a multi-column layout."
      colCount: "Rangschikt tekstvakken in een lay-out met meerdere kolommen."
    },
    masksettings: {
      // "Select if you want to store the question value with an applied mask in survey results."
      saveMaskedValue: "Selecteer of u de vraagwaarde met een toegepast masker wilt opslaan in enquêteresultaten."
    },
    patternmask: {
      // "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character."
      pattern: "Het patroon kan letterlijke tekenreeksen en de volgende tijdelijke aanduidingen bevatten: '9' - voor een cijfer; \"a\" - voor een hoofdletter of kleine letter; '#' - voor een cijfer of een hoofdletter of kleine letter. Gebruik backslash '\\' om een teken te escapen."
    },
    datetimemask: {
      // "The pattern can contain separator characters and the following placeholders:<br>`m` - Month number.<br>`mm` - Month number, with leading zero for single-digit values.<br>`d` - Day of the month.<br>`dd` - Day of the month, with leading zero for single-digit values.<br>`yy` - The last two digits of the year.<br>`yyyy` - Four-digit year.<br>`H` - Hours in 24-hour format.<br>`HH` - Hours in 24-hour format, with leading zero for single-digit values.<br>`h` - Hours in 12-hour format.<br>`hh` - Hours in 12-hour format, with leading zero for single-digit values.<br>`MM` - Minutes.<br>`ss` - Seconds.<br>`TT` - 12-hour clock period in upper case (AM/PM).<br>`tt` - 12-hour clock period in lower case (am/pm)."
      pattern: "Het patroon kan scheidingstekens en de volgende tijdelijke aanduidingen bevatten:<br>'m' - Maandnummer.<br>'mm' - Maandnummer, met voorloopnul voor eencijferige waarden. <br>'d' - Dag van de maand. <br>'dd' - Dag van de maand, met voorloopnul voor eencijferige waarden. <br>'yy' - De laatste twee cijfers van het jaar. <br>'yyyy' - Viercijferig jaartal. <br>'H' - Uren in 24-uursnotatie. <br>'HH' - Uren in 24-uursnotatie, met voorloopnul voor eencijferige waarden. <br>'h' - Uren in 12-uurs notatie. <br>'hh' - Uren in 12-uursnotatie, met voorloopnul voor eencijferige waarden. <br>\"MM\" - Notulen. <br>'ss' - Seconden. <br>'TT' - 12-uurs kloktijd in hoofdletters (AM/PM). <br>'tt' - 12-uurs kloktijd in kleine letters (am/pm)."
    },
    numericmask: {
      // "A symbol used to separate the fractional part from the integer part of a displayed number."
      decimalSeparator: "Een symbool dat wordt gebruikt om het fractionele deel te scheiden van het gehele deel van een weergegeven getal.",
      // "A symbol used to separate the digits of a large number into groups of three."
      thousandsSeparator: "Een symbool dat wordt gebruikt om de cijfers van een groot getal in groepen van drie te scheiden.",
      // "Limits how many digits to retain after the decimal point for a displayed number."
      precision: "Hiermee beperkt u het aantal cijfers dat moet worden behouden na de komma voor een weergegeven getal."
    },
    currencymask: {
      // "One or several symbols to be displayed before the value."
      prefix: "Een of meer symbolen die vóór de waarde moeten worden weergegeven.",
      // "One or several symbols to be displayed after the value."
      suffix: "Een of meer symbolen die na de waarde moeten worden weergegeven."
    },
    theme: {
      // "This setting applies only to questions outside of a panel."
      isPanelless: "Deze instelling is alleen van toepassing op vragen buiten een panel.",
      // "Sets a supplementary color that highlights key survey elements."
      primaryColor: "Hiermee stelt u een extra kleur in die de belangrijkste enquête-elementen markeert.",
      // "Adjusts the transparency of panels and question boxes relative to the survey background."
      panelBackgroundTransparency: "Hiermee past u de transparantie van deelvensters en vraagvakken aan ten opzichte van de achtergrond van de enquête.",
      // "Adjusts the transparency of input elements relative to the survey background."
      questionBackgroundTransparency: "Hiermee past u de transparantie van invoerelementen aan ten opzichte van de achtergrond van de enquête.",
      // "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes."
      cornerRadius: "Hiermee stelt u de hoekradius in voor alle rechthoekige elementen. Schakel de geavanceerde modus in als u afzonderlijke hoekradiuswaarden wilt instellen voor invoerelementen of deelvensters en vraagvakken.",
      // "Sets the main background color of the survey."
      "--sjs-general-backcolor-dim": "Hiermee stelt u de hoofdachtergrondkleur van de enquête in."
    },
    header: {
      // "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in."
      inheritWidthFrom: "Met de optie \"Zelfde als container\" wordt de breedte van het inhoudsgebied van de koptekst automatisch aangepast aan het HTML-element waarin de enquête wordt geplaatst.",
      // [Auto-translated] "The width of the header area that contains the survey title and description, measured in pixels."
      textAreaWidth: "De breedte van het koptekstgebied dat de titel en beschrijving van de enquête bevat, gemeten in pixels.",
      // [Auto-translated] "When enabled, the top of the survey overlays the bottom of the header."
      overlapEnabled: "Als deze optie is ingeschakeld, overlapt de bovenkant van de enquête de onderkant van de koptekst.",
      // [Auto-translated] "When set to 0, the height is calculated automatically to accommodate the header's content."
      mobileHeight: "Als deze optie is ingesteld op 0, wordt de hoogte automatisch berekend om de inhoud van de koptekst te accommoderen."
    },
    // "The \"Same as container\" option auto-adjusts the progress bar area width to fit into the HTML element the survey is placed in."
    progressBarInheritWidthFrom: "Met de optie \"Zelfde als container\" wordt de breedte van het gebied van de voortgangsbalk automatisch aangepast aan het HTML-element waarin de enquête is geplaatst.",
    // [Auto-translated] "Used when the 'Survey layout' is set to 'Single input field per page'. In this layout, the matrix is split so that each input field appears on a separate page. Use the {rowIndex} placeholder to insert auto numbering, {rowTitle} or {rowName} to reference the row's title or ID, and {row.columnid} to include the value of a specific matrix column."
    singleInputTitleTemplate: "Wordt gebruikt wanneer de 'Enquête-indeling' is ingesteld op 'Enkel invoerveld per pagina'. In deze lay-out wordt de matrix gesplitst zodat elk invoerveld op een aparte pagina verschijnt. Gebruik de tijdelijke aanduiding {rowIndex} om automatische nummering in te voegen, {rowTitle} of {rowName} om te verwijzen naar de titel of id van de rij en {row.columnid} om de waarde van een specifieke matrixkolom op te nemen."
  },
  // Properties
  p: {
    title: {
      // "title"
      name: "Titel",
      // "Leave it empty, if it is the same as 'Name'"
      title: "Laat het leeg als het hetzelfde is als 'Naam'"
    },
    // [Auto-translated] "Allow multiple selection"
    multiSelect: "Meerdere selecties toestaan",
    // [Auto-translated] "Show image and video captions"
    showLabel: "Afbeeldings- en videobijschriften weergeven",
    // [Auto-translated] "Swap the order of Yes and No"
    swapOrder: "Verwissel de volgorde van Ja en Nee",
    // [Auto-translated] "Value"
    value: "Waarde",
    // [Auto-translated] "Tab alignment"
    tabAlign: "Uitlijning van tabbladen",
    // [Auto-translated] "File source type"
    sourceType: "Type bestandsbron",
    // [Auto-translated] "Fit to container"
    fitToContainer: "Aanpassen aan container",
    // [Auto-translated] "Set value expression"
    setValueExpression: "Expressie van ingestelde waarde",
    // "Description"
    description: "Omschrijving", // Auto-generated string
    // [Auto-translated] "Logo fit"
    logoFit: "Logo past",
    // [Auto-translated] "Pages"
    pages: "Bladzijden", // Auto-generated string
    // [Auto-translated] "Questions"
    questions: "Vragen", // Auto-generated string
    // "Triggers"
    triggers: "Triggers",
    // [Auto-translated] "Custom variables"
    calculatedValues: "Aangepaste variabelen",
    // [Auto-translated] "Survey id"
    surveyId: "Enquête-id", // Auto-generated string
    // [Auto-translated] "Survey post id"
    surveyPostId: "Enquête post-ID", // Auto-generated string
    // [Auto-translated] "Survey show data saving"
    surveyShowDataSaving: "Enquête toont gegevensbesparing", // Auto-generated string
    // "Question description alignment"
    questionDescriptionLocation: "Plek vraagomschrijving",
    // "Progress bar type"
    progressBarType: "Type voortgangsbalk", // Auto-generated string
    // [Auto-translated] "Show table of contents (TOC)"
    showTOC: "Inhoudsopgave weergeven",
    // [Auto-translated] "TOC alignment"
    tocLocation: "TOC uitlijning",
    // [Auto-translated] "Question title pattern"
    questionTitlePattern: "Patroon van de vraagtitel", // Auto-generated string
    // [Auto-translated] "Survey width mode"
    widthMode: "Modus voor enquêtebreedte",
    // [Auto-translated] "Show brand info"
    showBrandInfo: "Toon merkinformatie", // Auto-generated string
    // "Use display values in dynamic texts"
    useDisplayValuesInDynamicTexts: "Waardes in titel gebruiken",
    // "Visible if"
    visibleIf: "Zichtbaar als", // Auto-generated string
    // [Auto-translated] "Default value expression"
    defaultValueExpression: "Standaardwaarde-expressie",
    // "Required if"
    requiredIf: "Vereist als", // Auto-generated string
    // [Auto-translated] "Reset value if"
    resetValueIf: "Waarde opnieuw instellen als",
    // [Auto-translated] "Set value if"
    setValueIf: "Stel de waarde in als",
    // "Validation rules"
    validators: "Validators",
    // [Auto-translated] "Bindings"
    bindings: "Bindings", // Auto-generated string
    // [Auto-translated] "Render as"
    renderAs: "Renderen als", // Auto-generated string
    // [Auto-translated] "Attach original items"
    attachData: "Voeg originele items toe", // Auto-generated string
    // "Choices"
    choices: "Keuzes",
    // "Choices by url"
    choicesByUrl: "Keuzes per url", // Auto-generated string
    // "Currency"
    currency: "Valuta", // Auto-generated string
    // [Auto-translated] "Cell hint"
    cellHint: "Hint voor cel", // Auto-generated string
    // [Auto-translated] "Total maximum fraction digits"
    totalMaximumFractionDigits: "Totaal maximum fractiecijfers", // Auto-generated string
    // [Auto-translated] "Total minimum fraction digits"
    totalMinimumFractionDigits: "Totaal minimum breukcijfers", // Auto-generated string
    // "Columns"
    columns: "Kolommen", // Auto-generated string
    // [Auto-translated] "Detail elements"
    detailElements: "Detailelementen", // Auto-generated string
    // [Auto-translated] "Allow adaptive actions"
    allowAdaptiveActions: "Adaptieve acties toestaan", // Auto-generated string
    // "Default row value"
    defaultRowValue: "Standaard rijwaarde", // Auto-generated string
    // [Auto-translated] "Auto-expand new row details"
    detailPanelShowOnAdding: "Nieuwe rijdetails automatisch uitvouwen",
    // [Auto-translated] "Choices lazy load enabled"
    choicesLazyLoadEnabled: "Keuzes lazy load ingeschakeld", // Auto-generated string
    // [Auto-translated] "Choices lazy load page size"
    choicesLazyLoadPageSize: "Keuzes lui laad paginaformaat", // Auto-generated string
    // [Auto-translated] "Input field component"
    inputFieldComponent: "Component invoerveld", // Auto-generated string
    // [Auto-translated] "Item component"
    itemComponent: "Onderdeel Item", // Auto-generated string
    // [Auto-translated] "Min"
    min: "Min", // Auto-generated string
    // [Auto-translated] "Max"
    max: "Max", // Auto-generated string
    // [Auto-translated] "Min value expression"
    minValueExpression: "Expressie van de min-waarde", // Auto-generated string
    // [Auto-translated] "Max value expression"
    maxValueExpression: "Maximale waarde-expressie", // Auto-generated string
    // [Auto-translated] "Step"
    step: "Stap", // Auto-generated string
    // [Auto-translated] "Items for auto-suggest"
    dataList: "Items voor automatische suggestie",
    // "Input field width (in characters)"
    inputSize: "Item grootte",
    // [Auto-translated] "Item label width"
    itemTitleWidth: "Breedte artikellabel",
    // [Auto-translated] "Input value alignment"
    inputTextAlignment: "Uitlijning van invoerwaarden",
    // [Auto-translated] "Elements"
    elements: "Elementen", // Auto-generated string
    // [Auto-translated] "Content"
    content: "Tevreden", // Auto-generated string
    // [Auto-translated] "Navigation title"
    navigationTitle: "Titel navigatie", // Auto-generated string
    // [Auto-translated] "Navigation description"
    navigationDescription: "Navigatie beschrijving", // Auto-generated string
    // [Auto-translated] "Long tap"
    longTap: "Lange tik", // Auto-generated string
    // [Auto-translated] "Expand input field dynamically"
    autoGrow: "Invoerveld dynamisch uitbreiden",
    // [Auto-translated] "Enable resize handle"
    allowResize: "Formaatgreep inschakelen",
    // [Auto-translated] "Accept carriage return"
    acceptCarriageReturn: "Accepteer retour vervoer", // Auto-generated string
    // [Auto-translated] "Display mode"
    displayMode: "Weergavemodus",
    // [Auto-translated] "Rate type"
    rateType: "Type tarief", // Auto-generated string
    // "Label"
    label: "Etiket", // Auto-generated string
    // [Auto-translated] "Content mode"
    contentMode: "Inhoudsmodus",
    // [Auto-translated] "Image and thumbnail fit"
    imageFit: "Afbeelding en miniatuur passen",
    // [Auto-translated] "Alt text"
    altText: "Alternatieve tekst",
    // [Auto-translated] "Height"
    height: "Hoogte", // Auto-generated string
    // [Auto-translated] "Height on smartphones"
    mobileHeight: "Hoogte op smartphones",
    // [Auto-translated] "Pen color"
    penColor: "Kleur van de pen", // Auto-generated string
    // [Auto-translated] "Background color"
    backgroundColor: "Achtergrondkleur",
    // [Auto-translated] "Template elements"
    templateElements: "Sjabloonelementen", // Auto-generated string
    // [Auto-translated] "Operator"
    operator: "Bediener", // Auto-generated string
    // [Auto-translated] "Is variable"
    isVariable: "Is variabel", // Auto-generated string
    // [Auto-translated] "Run expression"
    runExpression: "Expressie uitvoeren", // Auto-generated string
    // [Auto-translated] "Show caption"
    showCaption: "Toon bijschrift", // Auto-generated string
    // [Auto-translated] "Icon name"
    iconName: "Naam van pictogram", // Auto-generated string
    // [Auto-translated] "Icon size"
    iconSize: "Pictogramgrootte", // Auto-generated string
    // [Auto-translated] "Precision"
    precision: "Precisie", // Auto-generated string
    // [Auto-translated] "Matrix drag handle area"
    matrixDragHandleArea: "Matrix sleepgreep gebied", // Auto-generated string
    // [Auto-translated] "Background image"
    backgroundImage: "Achtergrondafbeelding",
    // [Auto-translated] "Background image fit"
    backgroundImageFit: "Passend op de achtergrondafbeelding", // Auto-generated string
    // [Auto-translated] "Background image attachment"
    backgroundImageAttachment: "Bijlage bij achtergrondafbeelding", // Auto-generated string
    // [Auto-translated] "Background opacity"
    backgroundOpacity: "Dekking op de achtergrond", // Auto-generated string
    // [Auto-translated] "Allow selective ranking"
    selectToRankEnabled: "Selectieve rangschikking toestaan",
    // [Auto-translated] "Ranking area alignment"
    selectToRankAreasLayout: "Uitlijning van het rangschikkingsgebied",
    // [Auto-translated] "Text to show if all options are selected"
    selectToRankEmptyRankedAreaText: "Tekst om aan te geven of alle opties zijn geselecteerd",
    // [Auto-translated] "Placeholder text for the ranking area"
    selectToRankEmptyUnrankedAreaText: "Tijdelijke tekst voor het rangschikkingsgebied",
    // [Auto-translated] "Allow camera access"
    allowCameraAccess: "Toegang tot de camera toestaan", // Auto-generated string
    // [Auto-translated] "Rating icon color mode"
    scaleColorMode: "Classificatiepictogram kleurmodus",
    // [Auto-translated] "Smileys color scheme"
    rateColorMode: "Smileys kleurenschema",
    // [Auto-translated] "Copy display value"
    copyDisplayValue: "Weergavewaarde kopiëren", // Auto-generated string
    // [Auto-translated] "Column span"
    effectiveColSpan: "Kolom spanwijdte",
    // [Auto-translated] "Progress bar area width"
    progressBarInheritWidthFrom: "Breedte van het voortgangsbalkgebied",
    // [Auto-translated] "Theme name"
    themeName: "Naam van het thema"
  },
  theme: {
    // "Advanced mode"
    advancedMode: "Geavanceerde modus",
    // "Page"
    pageTitle: "Lettertype voor paginatitel",
    // "Question box"
    questionTitle: "Lettertype voor de titel van de vraag",
    // "Input element"
    editorPanel: "Invoerelement",
    // [Auto-translated] "Lines"
    lines: "Lijnen",
    // [Auto-translated] "Default"
    primaryDefaultColor: "Verstek",
    // [Auto-translated] "Hover"
    primaryDarkColor: "Zweven",
    // [Auto-translated] "Selected"
    primaryLightColor: "Uitverkoren",
    // [Auto-translated] "Background color"
    backgroundDimColor: "Achtergrondkleur",
    // "Corner radius"
    cornerRadius: "De straal van de hoek",
    // [Auto-translated] "Default background"
    backcolor: "Standaard achtergrond",
    // [Auto-translated] "Hover background"
    hovercolor: "Achtergrond aanwijzen",
    // [Auto-translated] "Border decoration"
    borderDecoration: "Randdecoratie",
    // [Auto-translated] "Font color"
    fontColor: "Tekstkleur",
    // [Auto-translated] "Background color"
    backgroundColor: "Achtergrondkleur",
    // [Auto-translated] "Default color"
    primaryForecolor: "Standaardkleur",
    // [Auto-translated] "Disabled color"
    primaryForecolorLight: "Uitgeschakelde kleur",
    // [Auto-translated] "Font"
    font: "Lettertype",
    // [Auto-translated] "Darker"
    borderDefault: "Donkerder",
    // [Auto-translated] "Lighter"
    borderLight: "Aansteker",
    // [Auto-translated] "Font family"
    fontFamily: "Lettertype familie",
    // [Auto-translated] "Regular"
    fontWeightRegular: "Regelmatig",
    // [Auto-translated] "Heavy"
    fontWeightHeavy: "Zwaar",
    // [Auto-translated] "Semi-bold"
    fontWeightSemiBold: "Semi-vet",
    // [Auto-translated] "Bold"
    fontWeightBold: "Brutaal",
    // [Auto-translated] "Color"
    color: "Kleur",
    // [Auto-translated] "Placeholder color"
    placeholderColor: "Tijdelijke aanduiding voor kleur",
    // [Auto-translated] "Size"
    size: "Grootte",
    // [Auto-translated] "Opacity"
    opacity: "Dekking",
    // [Auto-translated] "X"
    boxShadowX: "X",
    // [Auto-translated] "Y"
    boxShadowY: "Y",
    // [Auto-translated] "Add Shadow Effect"
    boxShadowAddRule: "Schaduweffect toevoegen",
    // [Auto-translated] "Blur"
    boxShadowBlur: "Vervagen",
    // [Auto-translated] "Spread"
    boxShadowSpread: "Verspreiden",
    // [Auto-translated] "Drop"
    boxShadowDrop: "Druppel",
    // [Auto-translated] "Inner"
    boxShadowInner: "Binnenste",
    names: {
      // [Auto-translated] "Default"
      default: "Verstek",
      // [Auto-translated] "Sharp"
      sharp: "Scherp",
      // [Auto-translated] "Borderless"
      borderless: "Grenzeloos",
      // [Auto-translated] "Flat"
      flat: "Plat",
      // [Auto-translated] "Plain"
      plain: "Vlakte",
      // [Auto-translated] "Double Border"
      doubleborder: "Dubbele rand",
      // [Auto-translated] "Layered"
      layered: "Gelaagd",
      // [Auto-translated] "Solid"
      solid: "Degelijk",
      // [Auto-translated] "3D"
      threedimensional: ".3D",
      // [Auto-translated] "Contrast"
      contrast: "Tegenstelling"
    },
    colors: {
      // [Auto-translated] "Teal"
      teal: "Taling",
      // [Auto-translated] "Blue"
      blue: "Blauw",
      // [Auto-translated] "Purple"
      purple: "Paars",
      // [Auto-translated] "Orchid"
      orchid: "Orchidee",
      // [Auto-translated] "Tulip"
      tulip: "Tulp",
      // [Auto-translated] "Brown"
      brown: "Bruin",
      // [Auto-translated] "Green"
      green: "Groen",
      // [Auto-translated] "Gray"
      gray: "Grijs"
    }
  },
  creatortheme: {
    // [Auto-translated] "Surface background"
    "--sjs-special-background": "Oppervlakte achtergrond",
    // [Auto-translated] "Primary"
    "--sjs-primary-background-500": "Primair",
    // [Auto-translated] "Secondary"
    "--sjs-secondary-background-500": "Secundair",
    // [Auto-translated] "Surface"
    surfaceScale: "Oppervlak",
    // [Auto-translated] "UI elements"
    userInterfaceBaseUnit: "UI-elementen",
    // [Auto-translated] "Font"
    fontScale: "Lettertype",
    names: {
      // [Auto-translated] "Survey Creator 2020"
      sc2020: "Enquête maken 2020",
      // [Auto-translated] "Light"
      "default-light": "Licht",
      // [Auto-translated] "Dark"
      "default-dark": "Donker",
      // [Auto-translated] "Contrast"
      "default-contrast": "Tegenstelling"
    }
  }
};
setupLocale({ localeCode: "nl", strings: nlStrings });